/* KONYK — Central de Comando online. Gerado por ATACADO/central-online/gerar.py: nao editar a mao. */
/* ---- tema: automatico -> claro -> escuro ---- */
(function(){
  var r=document.documentElement, b=document.getElementById("bt-tema");
  if(!b) return;
  var gl=b.querySelector(".gl"), rot=b.querySelector(".rot");
  var ORDEM=["auto","claro","escuro"];
  var GL={auto:"\u25D0",claro:"\u2600",escuro:"\u263E"};
  var ROT={auto:"Auto",claro:"Claro",escuro:"Escuro"};
  function lido(){ try{ var t=localStorage.getItem("konyk-tema");
    return (t==="claro"||t==="escuro")? t : "auto"; }catch(e){ return "auto" } }
  function pinta(t){
    if(t==="claro") r.setAttribute("data-theme","light");
    else if(t==="escuro") r.setAttribute("data-theme","dark");
    else r.removeAttribute("data-theme");
    gl.textContent=GL[t]; rot.textContent=ROT[t];
    b.title = t==="auto" ? "Tema acompanha o sistema \u2014 clique para fixar claro"
            : t==="claro" ? "Tema claro fixo \u2014 clique para escuro"
                          : "Tema escuro fixo \u2014 clique para voltar ao automático";
  }
  pinta(lido());
  b.addEventListener("click",function(){
    var t=ORDEM[(ORDEM.indexOf(lido())+1)%3];
    try{ t==="auto" ? localStorage.removeItem("konyk-tema") : localStorage.setItem("konyk-tema",t) }catch(e){}
    pinta(t);
  });
})();

/* ---- densidade das linhas: compacta, normal, folgada ---- */
(function(){
  var r=document.documentElement, b=document.getElementById("bt-dens");
  if(!b) return;
  var gl=b.querySelector(".gl"), rot=b.querySelector(".rot");
  var ORDEM=["compacta","normal","folgada"];
  var GL={compacta:"\u2261",normal:"\u2261",folgada:"\u2261"};
  var ROT={compacta:"Compacta",normal:"Normal",folgada:"Folgada"};
  function lido(){ try{ var d=localStorage.getItem("konyk-densidade");
    return ORDEM.indexOf(d)>=0 ? d : "normal"; }catch(e){ return "normal" } }
  function pinta(d){
    if(d==="normal") r.removeAttribute("data-dens"); else r.setAttribute("data-dens",d);
    gl.textContent=GL[d]; rot.textContent=ROT[d];
    gl.style.letterSpacing = d==="compacta" ? "-.12em" : (d==="folgada" ? ".1em" : "0");
    b.title="Altura das linhas: "+ROT[d].toLowerCase()+" \u2014 clique para trocar";
  }
  pinta(lido());
  b.addEventListener("click",function(){
    var d=ORDEM[(ORDEM.indexOf(lido())+1)%3];
    try{ localStorage.setItem("konyk-densidade",d) }catch(e){}
    pinta(d);
  });
})();

/* ---- gaveta lateral: ficha do registro ---- */
(function(){
  var g=document.getElementById("gaveta"), f=document.getElementById("gav-fundo"),
      tt=document.getElementById("gav-tit"), sb=document.getElementById("gav-sub"),
      cp=document.getElementById("gav-corpo"), x=document.getElementById("gav-x");
  var voltar=null;
  function limpa(n){ while(n.firstChild) n.removeChild(n.firstChild); return n }
  window.fechaGaveta=function(){
    g.classList.remove("on"); f.classList.remove("on"); g.setAttribute("aria-hidden","true");
    if(voltar && voltar.focus) { try{ voltar.focus() }catch(e){} }
    voltar=null;
  };
  /* tit: texto. sub: lista de strings ou de nos. corpo: um no. */
  window.abreGaveta=function(tit,sub,corpo){
    voltar=document.activeElement;
    tt.textContent=tit||"—";
    limpa(sb);
    (sub||[]).forEach(function(s,i){
      if(i){ var p=document.createElement("span"); p.textContent="·"; p.style.opacity=".5"; sb.appendChild(p) }
      if(typeof s==="string"){ var e=document.createElement("span"); e.textContent=s; sb.appendChild(e) }
      else if(s) sb.appendChild(s);
    });
    limpa(cp); if(corpo) cp.appendChild(corpo);
    g.classList.add("on"); f.classList.add("on"); g.setAttribute("aria-hidden","false");
    cp.scrollTop=0;
    setTimeout(function(){ try{ x.focus() }catch(e){} },40);
  };
  x.addEventListener("click",window.fechaGaveta);
  f.addEventListener("click",window.fechaGaveta);
  document.addEventListener("keydown",function(ev){
    if(ev.key==="Escape" && g.classList.contains("on")) window.fechaGaveta();
  });
})();


/* ---- filtros lembrados por aba ---- */
(function(){
  var CH="konyk-filtros";
  function ler(){ try{ return JSON.parse(localStorage.getItem(CH)||"{}")||{} }catch(e){ return {} } }
  function grava(){
    var v={};
    document.querySelectorAll(".filtros select, .filtros input").forEach(function(n){
      if(!n.id) return;
      v[n.id] = n.type==="checkbox" ? !!n.checked : n.value;
    });
    try{ localStorage.setItem(CH, JSON.stringify(v)) }catch(e){}
  }
  window.restauraFiltros=function(){
    var v=ler();
    Object.keys(v).forEach(function(id){
      var n=document.getElementById(id); if(!n) return;
      if(n.type==="checkbox"){ if(!!n.checked!==!!v[id]) n.checked=!!v[id]; }
      else if(n.tagName==="SELECT"){
        var tem=Array.prototype.some.call(n.options,function(o){return o.value===v[id]});
        if(tem && n.value!==v[id]) n.value=v[id];
      } else if(n.value!==v[id]) n.value=v[id];
    });
  };
  document.addEventListener("input",function(ev){
    if(ev.target && ev.target.closest && ev.target.closest(".filtros")) grava();
  },true);
  document.addEventListener("change",function(ev){
    if(ev.target && ev.target.closest && ev.target.closest(".filtros")) grava();
  },true);
})();

/* ---- teclado: backoffice se opera com as mãos no teclado ---- */
(function(){
  var ATALHOS=[
    ["/","foca a busca da aba"],
    ["1 a 9","abre a aba correspondente"],
    ["j / k","desce e sobe uma linha"],
    ["Enter","abre a ficha da linha"],
    ["x","marca ou desmarca a linha"],
    ["a","marca todas as linhas da página"],
    ["e","exporta o que está filtrado"],
    ["Esc","fecha a ficha, limpa a seleção ou sai do campo"],
    ["?","mostra esta lista"]
  ];
  var BUSCA={geral:null, conf:null, fila:"f-fila-q", lojistas:null, ped:null,
             cat:"f-cat-q", base:"f-q", reps:"f-rep-q", pol:null, end:"f-end-q"};
  function aba(){ return (window.abaAtual && window.abaAtual()) || "geral" }
  function corpo(){ var s=document.querySelector("section:not([hidden]) tbody"); return s }
  function linhas(){ var t=corpo(); return t? Array.prototype.slice.call(t.rows) : [] }
  /* o cursor vive pelo índice, não pelo nó: marcar uma linha redesenha a tabela
     e o nó anterior deixa de existir */
  var focoIdx=-1;
  function aplicaFoco(rolar){
    var L=linhas();
    document.querySelectorAll("tr.cursor").forEach(function(r){ r.classList.remove("cursor") });
    if(focoIdx<0 || !L.length) return;
    if(focoIdx>=L.length) focoIdx=L.length-1;
    L[focoIdx].classList.add("cursor");
    if(rolar) L[focoIdx].scrollIntoView({block:"nearest"});
  }
  function foco(){ return document.querySelector("section:not([hidden]) tr.cursor") }
  function moveFoco(d){
    var L=linhas(); if(!L.length) return;
    focoIdx = focoIdx<0 ? (d>0?0:L.length-1) : Math.min(L.length-1, Math.max(0, focoIdx+d));
    aplicaFoco(true);
  }
  window.zeraFoco=function(){ focoIdx=-1; };
  var reaplicar=null;
  new MutationObserver(function(){
    if(focoIdx<0) return;
    clearTimeout(reaplicar);
    reaplicar=setTimeout(function(){ aplicaFoco(false) },30);
  }).observe(document.body,{childList:true,subtree:true});
  function digitando(e){
    var t=e.target, n=t && t.tagName;
    return n==="INPUT"||n==="SELECT"||n==="TEXTAREA"||(t&&t.isContentEditable);
  }
  function ajuda(){
    if(!window.abreGaveta) return;
    var box=document.createElement("div");
    box.style.cssText="display:grid;gap:16px";
    var dl=document.createElement("dl");
    ATALHOS.forEach(function(a){
      var r=document.createElement("div"); r.className="par";
      var dt=document.createElement("dt"); dt.textContent=a[0];
      var dd=document.createElement("dd"); dd.textContent=a[1];
      r.appendChild(dt); r.appendChild(dd); dl.appendChild(r);
    });
    box.appendChild(dl);
    var p=document.createElement("p"); p.className="nota";
    p.textContent="Os atalhos valem quando o foco não está dentro de um campo. Dentro de um campo, só o Esc responde.";
    box.appendChild(p);
    window.abreGaveta("Atalhos de teclado", ["teclado"], box);
  }
  window.ajudaAtalhos=ajuda;
  var ba=document.getElementById("bt-atalhos");
  if(ba) ba.addEventListener("click",ajuda);
  document.addEventListener("keydown",function(e){
    if(e.ctrlKey||e.metaKey||e.altKey) return;
    if(e.key==="Escape"){
      if(digitando(e)){ e.target.blur(); return }
      return; /* a gaveta trata o Esc dela */
    }
    if(digitando(e)) return;
    var k=e.key;
    if(k==="/"){ 
      var id=BUSCA[aba()];
      var c=id? document.getElementById(id) : document.getElementById("busca-geral");
      if(c){ e.preventDefault(); c.focus(); c.select && c.select(); }
      return;
    }
    if(k==="?"){ e.preventDefault(); ajuda(); return }
    if(/^[1-9]$/.test(k)){
      var bs=document.querySelectorAll("#rail .nav-bt");
      var i=parseInt(k,10)-1;
      if(bs[i]){ e.preventDefault(); bs[i].click() }
      return;
    }
    if(k==="j"||k==="ArrowDown"){ if(linhas().length){ e.preventDefault(); moveFoco(1) } return }
    if(k==="k"||k==="ArrowUp"){ if(linhas().length){ e.preventDefault(); moveFoco(-1) } return }
    if(k==="Enter"){
      var r=foco(); if(!r) return;
      var b=r.querySelector(".lim.nome, button.lim");
      if(b && b.click){ e.preventDefault(); b.click() }
      return;
    }
    if(k==="x"){
      var r2=foco(); if(!r2) return;
      var cx=r2.querySelector("td.caixa input");
      if(cx){ e.preventDefault(); cx.checked=!cx.checked; cx.onchange && cx.onchange(); }
      return;
    }
    if(k==="a"){
      var th=document.querySelector("section:not([hidden]) th.caixa input");
      if(th){ e.preventDefault(); th.checked=!th.checked; th.onchange && th.onchange(); }
      return;
    }
    if(k==="e"){
      var ex=document.querySelector("section:not([hidden]) .bt-exp");
      if(ex){ e.preventDefault(); ex.click() }
      return;
    }
  });
})();

/* ---- busca do topo: joga na busca da aba aberta, ou abre a Base historica ---- */
(function(){
  var b=document.getElementById("busca-geral");
  if(!b) return;
  var MAPA={fila:"f-fila-q", cat:"f-cat-q", base:"f-q", reps:"f-rep-q", end:"f-end-q"};
  b.addEventListener("input",function(){
    var aba=(window.abaAtual && window.abaAtual()) || "base";
    var alvo=MAPA[aba];
    if(!alvo){ if(window.vai) window.vai("base"); alvo="f-q"; }
    var c=document.getElementById(alvo);
    if(c){ c.value=b.value; c.dispatchEvent(new Event("input",{bubbles:true})); }
  });
})();

(function(){
"use strict";

/* ---------------- banco ---------------- */
var SUPA_URL = "https://mujdswvpyagodzngzjfn.supabase.co";
var SUPA_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im11amRzd3ZweWFnb2R6bmd6amZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODk5Nzk4OTMsImV4cCI6MjEwNTU1NTg5M30.7ias8WKA1GnO9PHg7BXO2cZD_9152kG04EJhXeg1OYI";
var sb = null;
function b2b(t){ return sb.schema("b2b").from(t) }
/* fase 1: a Central online so le. Gravar volta na fase 2. */
var SO_LEITURA = "Só leitura nesta fase: gravar volta na fase 2. Use a Central local para anotar até lá.";
function soLeitura(){ toast(SO_LEITURA); return false }

/* ---------------- estado ---------------- */
var BASE = {lojistas:[]}, REPS = {representantes:[]};
var LIVE = {empresas:null, pedidos:null, catalogo:null, tabela:null, fila:null};
var ERRO = {};
var PEND = {};
var PROSP = {};
var CONF  = {};
var REGUA = null;
var FONTE_FILA = "";
var LIDO_EM = null;

/* medição feita em 30/09/2026 na tabela de preços do atacado da Shopify */
var TABELA_MEDIDA = {nome:"ATACADO 2026 — preços de lojista", tipo:"PERCENTAGE_DECREASE",
  valor:0, fixos:0, catalogo:"ATACADO 2026", ativo:true, semDesconto:true, medidoEm:"30/09/2026"};

var ABAS = [
  {id:"geral",   rot:"Hoje",             grupo:"Trabalho"},
  {id:"base",    rot:"Lojistas",         grupo:"Trabalho"},
  {id:"cat",     rot:"Produto e preço",  grupo:"Trabalho"},
  {id:"conf",    rot:"Conformidade",     grupo:"Referência"},
  {id:"reps",    rot:"Representantes",   grupo:"Referência"},
  {id:"end",     rot:"Endereços",        grupo:"Estoque"}
];
var ESTADOS = {
  "contatado":{rot:"Contatado", cls:"i"},
  "negociando":{rot:"Negociando", cls:"c"},
  "reativado":{rot:"Reativado", cls:"v"},
  "sem-interesse":{rot:"Sem interesse", cls:""},
  "invalido":{rot:"Contato inválido", cls:"r"}
};
var TIPOS = {
  "lojista":{rot:"Lojista atacado", cls:"i"},
  "franquia":{rot:"Franquia", cls:"c"},
  "loja-propria":{rot:"Loja própria", cls:""},
  "private-label":{rot:"Private label", cls:""},
  "sem-pedido":{rot:"Sem pedido", cls:""},
  "outro":{rot:"Outro", cls:""}
};

/* ---------------- utilidades ---------------- */
function $(s,r){return (r||document).querySelector(s)}
function el(t,c,x){var e=document.createElement(t); if(c)e.className=c; if(x!=null)e.textContent=x; return e}
function moeda(v){ if(v==null||isNaN(v))return "—"; return "R$ "+Number(v).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2}); }
function moedaC(v){ if(v==null||isNaN(v))return "—"; return "R$ "+Number(v).toLocaleString("pt-BR",{maximumFractionDigits:0}); }
function inteiro(v){ if(v==null||isNaN(v))return "—"; return Number(v).toLocaleString("pt-BR"); }
function pct(v){ return (Number(v)||0).toLocaleString("pt-BR",{maximumFractionDigits:1})+"%" }
function dataBr(s){ if(!s)return "—"; var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(s); return m? m[3]+"/"+m[2]+"/"+m[1] : String(s).slice(0,10); }
function cnpjBr(c){ c=String(c||"").replace(/\D/g,""); if(c.length!==14)return c||"—";
  return c.slice(0,2)+"."+c.slice(2,5)+"."+c.slice(5,8)+"/"+c.slice(8,12)+"-"+c.slice(12); }
function telBr(t){ var d=String(t||"").replace(/\D/g,""); if(d.length<10)return t||"—";
  if(d.length===11) return "("+d.slice(0,2)+") "+d.slice(2,7)+"-"+d.slice(7);
  return "("+d.slice(0,2)+") "+d.slice(2,6)+"-"+d.slice(6); }
function anos(ult){ if(!ult)return null; var a=parseInt(String(ult).slice(0,4),10); if(!a)return null; return 2026-a; }
function tagEl(rot,cls){ return el("span","tag"+(cls?" "+cls:""),rot) }
function limpa(n){ while(n.firstChild) n.removeChild(n.firstChild); return n }
function ref(sku){ var s=String(sku||""); return s.length>=12 ? s.slice(0,12) : s }
function agora(){ return new Date().toLocaleString("pt-BR",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"}) }

/* ---------------- navegação ---------------- */
var abaAtual = "geral";
function montaNav(){
  var rl=$("#rail"), pe=$(".rail-pe"), grupo=null;
  ABAS.forEach(function(a){
    if(a.grupo!==grupo){ grupo=a.grupo; rl.insertBefore(el("div","trilha-tit",grupo), pe); }
    var b=el("button","nav-bt"); b.type="button";
    b.appendChild(document.createTextNode(a.rot));
    var c=el("span","c",""); c.id="cont-"+a.id; b.appendChild(c);
    b.onclick=function(){ vai(a.id) }; b.setAttribute("data-aba",a.id);
    rl.insertBefore(b, pe);
  });
}
function vai(id){
  abaAtual=id;
  ABAS.forEach(function(a){
    var s=$("#s-"+a.id); if(s) s.hidden = (a.id!==id);
    Array.prototype.forEach.call(document.querySelectorAll('[data-aba="'+a.id+'"]'),function(b){
      b.setAttribute("aria-current", a.id===id ? "true":"false");
    });
  });
  var t=$("#trilho"); if(t){ var r=ABAS.filter(function(a){return a.id===id})[0]; if(r) t.textContent=r.rot; }
  if(window.fechaGaveta) window.fechaGaveta();
  var sb=document.getElementById("selbar");
  if(sb && id!=="base"){ sb.hidden=true; document.body.classList.remove("com-selbar"); }
  if(window.zeraFoco) window.zeraFoco();
  try{ localStorage.setItem("knk-aba",id) }catch(e){}
  window.scrollTo({top:0,behavior:"auto"});
}
window.vai=vai;
window.abaAtual=function(){ return abaAtual };
function contador(id,n){ var c=$("#cont-"+id); if(c) c.textContent = (n==null? "" : String(n)); }
var LEITURA_EM=null, LEITURA_CLS="";
function selo(txt,cls){
  var s=$("#selo-fonte"); if(!s) return;
  s.textContent=txt; s.className="selo"+(cls?" "+cls:"");
  LEITURA_CLS=cls||"";
  if(cls==="viva"){ LEITURA_EM=Date.now(); s.title="Leitura desta sessão"; }
  envelhece();
}
/* dado velho não pode ter cara de dado novo */
function envelhece(){
  var s=$("#selo-fonte"); if(!s || LEITURA_CLS!=="viva" || !LEITURA_EM) return;
  var min=Math.round((Date.now()-LEITURA_EM)/60000);
  if(min>=15){
    s.className="selo pre";
    s.title="Esta leitura tem "+min+" minutos. Clique em Atualizar para reler.";
  } else {
    s.className="selo viva";
    s.title="Lido há "+(min<1?"menos de um minuto":min+(min===1?" minuto":" minutos"));
  }
}
setInterval(envelhece, 60000);

/* ---------------- leitura ---------------- */
function sessaoCaiu(err){
  var m=String((err&&(err.message||err.code))||"");
  return /JWT|jwt|42501|negado|not authorized/i.test(m);
}
function carregaLive(){
  selo("Consultando o banco…");
  return sb.schema("b2b").rpc("painel_hoje").then(function(r){
    if(r.error || !r.data){
      if(sessaoCaiu(r.error)){ mostraEntrada("Sua sessão expirou. Entre de novo."); return; }
      ERRO.fila="painel"; selo("O banco não respondeu","pre"); pintaTudo(); return;
    }
    var d=r.data;
    LIDO_EM = agora();
    delete ERRO.fila;
    FONTE_FILA = "supabase";
    LIVE.fila = (d.leads||[]).map(function(r){ return {
      key:"lead-"+(r.id||""), lead_id:r.id||"", criado:r.created_at||"",
      empresa:r.razao_social||r.nome_fantasia||"", cnpj:r.cnpj||"", nome:r.contato_nome||"",
      email:r.email||"", telefone:r.telefone||"", cidade:r.cidade||"", uf:r.uf||"",
      status:(r.status||"novo"), obs:r.mensagem||"", atualizado:r.updated_at||"",
      provisionado: !!r.shopify_company_id
    }; });
    LIVE.empresas = d.empresas||[];
    LIVE.pedidos  = d.pedidos||[];
    LIVE.catalogo = d.catalogo||null;
    if(d.erro_catalogo) ERRO.catalogo=d.erro_catalogo; else delete ERRO.catalogo;
    LIVE.tabela   = null;
    selo("Lido às "+LIDO_EM,"viva");
    pintaTudo();
  }, function(){
    ERRO.fila="rede"; selo("Sem conexão com o banco","pre"); pintaTudo();
  });
}

/* base historica, representantes, enderecos e regua: tabelas do schema b2b.
   O PostgREST devolve no maximo 1000 linhas por chamada, entao pagina. */
function tudo(mk){
  var out=[], pag=1000;
  function vez(i){
    return mk().range(i,i+pag-1).then(function(r){
      if(r.error) throw r.error;
      var d=r.data||[]; out=out.concat(d);
      return d.length===pag? vez(i+pag) : out;
    });
  }
  return vez(0);
}
function dmy(iso){ var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(iso||""); return m? m[3]+"/"+m[2]+"/"+m[1] : "" }
function lojistaDe(p){
  return {cnpj:p.cnpj_digits||p.cnpj||"", nome:p.razao_social||p.nome_fantasia||"",
    cidade:p.cidade||"", uf:p.uf||"", contato:p.contato_nome||"", tel:p.telefone||"", wa:p.whatsapp||"",
    email:p.email||"", cadastro:dmy(p.cadastro_sisfab), tipo:p.hist_tipo||"outro",
    ped:p.hist_pedidos||0, pc:p.hist_pecas||0, vr:Number(p.hist_valor)||0,
    pri:p.hist_primeiro||"", ult:p.hist_ultimo||"", rep:p.hist_rep||"", tab:p.hist_tabela||"",
    cond:p.hist_condicao||"", teto:p.hist_teto20?1:0,
    sit:p.rf_situacao||"", at:p.rf_situacao==="ATIVA"?1:0, perf:p.perfil||"", cnae:p.rf_cnae||"",
    mun:p.rf_municipio||"", ufr:p.rf_uf||"", mot:p.rf_motivo||"", dsd:p.rf_desde||"",
    prt:p.rf_porte||"", smp:p.rf_simples||"", mud:p.rf_mudou?1:0, rfnome:p.rf_razao||""};
}
function repDe(r){
  var f=r.rf||{};
  return {cod:String(r.codigo_sisfab==null?"":r.codigo_sisfab), nome:r.nome||"", cnpj:r.cnpj_digits||r.cnpj||"",
    contato:r.contato_nome||"", cidade:titulo(r.cidade||""), uf:r.uf||"", tel:r.telefone||"", wa:r.whatsapp||"",
    email:r.email||"", cli:r.hist_clientes||0, ped:r.hist_pedidos||0, pc:r.hist_pecas||0,
    vr:Number(r.hist_receita)||0, pri:f.pri||"", ult:r.hist_ultimo||"", ufs:r.estados||[],
    sit:f.sit||"", at:f.at||0, perf:f.perf||"", cnae:f.cnae||"", mun:f.mun||"", ufr:f.ufr||"",
    mot:f.mot||"", dsd:f.dsd||"", prt:f.prt||"", smp:f.smp||"", mud:f.mud||0, rfnome:f.rfnome||""};
}
/* b2b.enderecos (uma linha por SKU x prateleira) volta para o formato compacto da aba Enderecos */
function endbDe(linhas, lay){
  var cats=(lay.categorias||[]).map(function(c){return c[0]}), cap=(lay.categorias||[]).map(function(c){return c[1]});
  var refs={}, porSku={};
  linhas.forEach(function(l){
    var s=porSku[l.sku];
    if(!s){ s=porSku[l.sku]={sku:l.sku, cor:l.cor||"", tam:l.tamanho||"", o:l.origem, pos:[], tot:0};
      if(!refs[l.ref]) refs[l.ref]=[l.produto||"—", Math.max(0,cats.indexOf(l.categoria))]; }
    s.pos.push([l.endereco, l.qtd]); s.tot+=l.qtd;
  });
  var skus=Object.keys(porSku).map(function(k){
    var s=porSku[k]; s.pos.sort(function(a,b){ return a[0]<b[0]?-1:a[0]>b[0]?1:0 });
    return [s.sku, s.cor, s.tam, s.o==="ecom"?s.tot:0, s.o==="nf"?s.tot:0, 0, s.pos];
  });
  skus.sort(function(a,b){ var x=a[6][0][0], y=b[6][0][0]; return x<y?-1:x>y?1:(a[0]<b[0]?-1:1) });
  return {gerado_em:"2026-10-20", versao:1,
    fonte:"b2b.enderecos no Supabase — plano único de 20/10/2026 (estoque ativo do e-commerce + NF-e 35100)",
    estantes:lay.estantes||[], niveis:lay.niveis||6, cats:cats, cap:cap, refs:refs, skus:skus};
}
/* ---------------- regua: salvar no banco, aplicar no site (fase 2) ---------------- */
var REGUA_META = {regua:null, site:[]};
function dataHora(iso){ if(!iso) return ""; var d=new Date(iso);
  return d.toLocaleDateString("pt-BR")+" "+d.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}) }
function pctBr(v){ return String(Number(v)).replace(".",",")+"%" }
function reguaDoBanco(g){
  var f=g.faixas||{};
  return {faixas:Object.keys(f).map(function(k){return {min:Number(k), pct:Number(f[k])}})
           .sort(function(a,b){return a.min-b.min}),
         fator:Math.round(Number(g.fator_atacado)/Number(g.markup_etiqueta)*100)/100};
}
function reguaIgual(a,b){
  function norm(x){ return JSON.stringify((x&&x.faixas||[]).map(function(f){return [Number(f.min),Number(f.pct)]})
    .sort(function(p,q){return p[0]-q[0]})) }
  return norm(a)===norm(b);
}
function reguaMsg(titulo, linhas, cls){
  var m=$("#regua-msg"); if(!m) return; limpa(m);
  if(!titulo){ m.hidden=true; return }
  m.hidden=false; m.className="regua-msg "+(cls||"");
  m.appendChild(el("b",null,titulo));
  if(linhas && linhas.length){ var ul=el("ul"); linhas.forEach(function(l){ ul.appendChild(el("li",null,l)) }); m.appendChild(ul) }
}
function reguaEstado(){
  var g=REGUA_META.regua, s=REGUA_META.site||[];
  var e=$("#regua-estado"); if(!e) return;
  var txt;
  if(!g) txt="nada salvo ainda";
  else {
    txt="salva em "+dataHora(g.criado_em)+(g.autor_email?" por "+g.autor_email:"");
    if(s.length) txt+=" · no site: "+s.map(function(x){return pctBr(x.pct)+" a partir de "+x.min_pecas}).join(", ");
    else if(g.pausada_em) txt+=" · pausada no site em "+dataHora(g.pausada_em);
    else txt+=" · ainda não está no site";
  }
  if(reguaRasc && REGUA && !reguaIgual(reguaRasc,REGUA)) txt+=" · há mudanças não salvas";
  e.textContent=txt;
  var ba=$("#bt-regua-aplicar"), bp=$("#bt-regua-pausar");
  if(ba) ba.disabled=!g; if(bp) bp.disabled=!s.length;
}
function recarregaRegua(){
  return Promise.all([
    b2b("regua_varejo").select("id,faixas,fator_atacado,markup_etiqueta,criado_em,autor_email,aplicada_em,aplicada_por,pausada_em").eq("ativa",true).limit(1),
    b2b("regua_shopify").select("discount_id,min_pecas,pct,atualizado_em").order("min_pecas")
  ]).then(function(r){
    REGUA_META={regua:(r[0].data||[])[0]||null, site:r[1].data||[]};
    if(REGUA_META.regua) REGUA=reguaDoBanco(REGUA_META.regua);
    reguaEstado();
  });
}
function salvaRegua(){
  var faixas=reguaRasc.faixas.map(function(f){return {min:Number(f.min), pct:Number(f.pct)}});
  var b=$("#bt-regua-salvar"); b.disabled=true;
  sb.schema("b2b").rpc("regua_salvar",{p_faixas:faixas}).then(function(r){
    b.disabled=false;
    if(r.error){ if(sessaoCaiu(r.error)) return mostraEntrada("Sua sessão expirou. Entre de novo.");
      return reguaMsg("Não consegui salvar.",[r.error.message],"cr"); }
    var d=r.data||{};
    if(!d.ok) return reguaMsg("A régua não foi salva:", d.erros||[], "cr");
    reguaRasc=null;
    recarregaRegua().then(function(){
      pintaRegua(); pintaGeral();
      reguaMsg("Régua salva. Ela ainda não está no site: confira e clique em “Aplicar no site”.", d.alertas||[], (d.alertas&&d.alertas.length)?"al":"ok");
    });
  }, function(){ b.disabled=false; reguaMsg("Sem conexão com o banco.",[],"cr") });
}
function aplicaRegua(){
  if(reguaRasc && REGUA && !reguaIgual(reguaRasc,REGUA))
    return reguaMsg("Há mudanças não salvas na régua. Salve antes de aplicar no site.",[],"al");
  var f=(REGUA&&REGUA.faixas)||[];
  if(!f.length) return;
  var lista=f.map(function(x){return "• "+pctBr(x.pct)+" a partir de "+x.min+" peças"}).join("\n");
  if(!window.confirm("Aplicar no site agora?\n\n"+lista+"\n\nVale na hora para todos os clientes da loja, somando com os 5% do Pix. O Leve 6 pague 5 fica de reserva.")) return;
  var b=$("#bt-regua-aplicar"); b.disabled=true; b.textContent="Aplicando…";
  sb.schema("b2b").rpc("regua_aplicar",{p_teste:false}).then(function(r){
    b.textContent="Aplicar no site";
    if(r.error){ b.disabled=false; if(sessaoCaiu(r.error)) return mostraEntrada("Sua sessão expirou. Entre de novo.");
      return reguaMsg("Não consegui aplicar.",[r.error.message],"cr"); }
    var d=r.data||{};
    recarregaRegua().then(function(){
      if(!d.ok) return reguaMsg("A régua não foi aplicada:", d.mensagem?[d.mensagem]:(d.erros||[]), "cr");
      reguaMsg("Régua aplicada no site.", (d.faixas||[]).map(function(x){
        return pctBr(x.pct)+" a partir de "+x.min+" peças: "+x.acao }), "ok");
    });
  }, function(){ b.disabled=false; b.textContent="Aplicar no site"; reguaMsg("Sem conexão com o banco.",[],"cr") });
}
function pausaRegua(){
  if(!window.confirm("Tirar a régua do site agora? Os descontos por quantidade param de valer e o Leve 6 pague 5 volta a ser o único.")) return;
  var b=$("#bt-regua-pausar"); b.disabled=true;
  sb.schema("b2b").rpc("regua_pausar").then(function(r){
    var d=(r&&r.data)||{};
    recarregaRegua().then(function(){
      if(r.error) return reguaMsg("Não consegui pausar.",[r.error.message],"cr");
      if(!d.ok) return reguaMsg("A régua não foi pausada:", d.mensagem?[d.mensagem]:(d.erros||[]), "cr");
      reguaMsg("Régua tirada do site ("+d.removidas+" faixas removidas).",[],"ok");
    });
  });
}

function carregaBanco(){
  selo("Lendo o banco…");
  return Promise.all([
    tudo(function(){ return b2b("prospects").select("*").order("id") }),
    tudo(function(){ return b2b("representantes").select("*").order("id") }),
    tudo(function(){ return b2b("enderecos").select("sku,endereco,qtd,ref,cor,tamanho,produto,categoria,origem").order("sku").order("endereco") }),
    b2b("config").select("chave,valor").in("chave",["enderecos_layout"]),
    b2b("regua_varejo").select("id,faixas,fator_atacado,markup_etiqueta,criado_em,autor_email,aplicada_em,aplicada_por,pausada_em").eq("ativa",true).limit(1),
    b2b("regua_shopify").select("discount_id,min_pecas,pct,atualizado_em").order("min_pecas")
  ]).then(function(r){
    REGUA_META = {regua:(r[4].data||[])[0]||null, site:r[5].data||[]};
    BASE = {lojistas:r[0].map(lojistaDe)};
    BASE.lojistas.sort(function(a,b){ return a.nome<b.nome?-1:a.nome>b.nome?1:0 });
    REPS = {representantes:r[1].map(repDe)};
    var lay=((r[3].data||[])[0]||{}).valor||{};
    ENDB = r[2].length? endbDe(r[2], lay) : null;
    var g=(r[4].data||[])[0];
    if(g){
      REGUA=reguaDoBanco(g);
      var pf=$("#p-fator"); if(pf && REGUA.fator) pf.value=REGUA.fator;
    }
    /* estado de prospeccao gravado no banco (fase 1: so leitura) */
    PROSP={};
    r[0].forEach(function(p){
      var e=p.estado==="nao_contatado"? "" : (p.estado||"");
      if(e||p.nota||p.proximo_em||p.tentativas)
        PROSP[p.cnpj_digits||p.cnpj]={estado:e, nota:p.nota||"", prox:p.proximo_em||"", tent:p.tentativas||0};
    });
  });
}

/* ---------------- estado local ---------------- */
function carregaLocal(){ /* fase 1: estado vem do banco (carregaBanco) */ }
/* conferências manuais da arquitetura: data e observação por item */
function salvaConf(id, campos){
  var n={em:"",obs:""}, a=CONF[id]||{};
  Object.keys(a).forEach(function(k){ n[k]=a[k] });
  Object.keys(campos).forEach(function(k){ n[k]=campos[k] });
  return soLeitura();
}
/* prospecção: estado, nota, próximo contato e nº de tentativas, tudo por CNPJ */
function gravaProsp(cnpj,campos){
  var n={estado:"",nota:"",prox:"",tent:0}, a=PROSP[cnpj]||{};
  Object.keys(a).forEach(function(k){ n[k]=a[k] });
  Object.keys(campos).forEach(function(k){ n[k]=campos[k] });
  n.quando=new Date().toISOString();
  PROSP[cnpj]=n; return n;
}
function persisteProsp(){ return false }
function salvaProsp(cnpj, estado, nota){
  soLeitura(); pintaBase(); return false;
  gravaProsp(cnpj,{estado:estado||"", nota:nota||""});
  pintaBase();
  return persisteProsp();
}
function salvaProsp2(cnpj, campos){
  soLeitura(); pintaBase(); return false;
  gravaProsp(cnpj,campos); pintaBase(); pintaGeral();
  return persisteProsp();
}
function salvaProspLote(cnpjs, campos, foto){
  soLeitura(); return 0;
  cnpjs.forEach(function(c){ gravaProsp(c, foto ? (foto[c]||{}) : (campos||{})) });
  pintaBase(); pintaGeral();
  return persisteProsp()? cnpjs.length : 0;
}
function reguaPadrao(){ return {faixas:[{min:3,pct:5},{min:6,pct:8},{min:10,pct:12}], fator:0.55}; }
function reguaAtual(){ return REGUA || reguaPadrao(); }

/* ================= VISÃO GERAL ================= */
function statTabela(){ return TABELA_MEDIDA; }
function statTabelaAoVivo(){
  if(!LIVE.tabela) return null;
  var t = LIVE.tabela.filter(function(x){ return /ATACADO/i.test(x.name||"") })[0] || LIVE.tabela[0];
  if(!t) return null;
  var aj = t.parent && t.parent.adjustment || null;
  var vl = aj ? Number(aj.value)||0 : 0;
  var dec = aj && aj.type==="PERCENTAGE_DECREASE";
  return {nome:t.name, tipo:aj?aj.type:"—", valor:vl, fixos:Number(t.fixedPricesCount)||0,
          catalogo:t.catalog?t.catalog.title:"—", ativo:t.catalog&&t.catalog.status==="ACTIVE",
          semDesconto: (!dec || vl===0) && (Number(t.fixedPricesCount)||0)===0};
}
function baseNum(){
  var L=BASE.lojistas||[];
  var ch=L.filter(function(x){return x.ped>0});
  return {
    total:L.length, comHist:ch.length,
    tel:L.filter(function(x){return x.tel}).length,
    email:L.filter(function(x){return x.email}).length,
    lojista:L.filter(function(x){return x.tipo==="lojista"}).length,
    vr:ch.reduce(function(a,b){return a+(b.vr||0)},0),
    pc:ch.reduce(function(a,b){return a+(b.pc||0)},0),
    ped:ch.reduce(function(a,b){return a+(b.ped||0)},0),
    trab:Object.keys(PROSP).filter(function(k){return PROSP[k]&&PROSP[k].estado}).length
  };
}
function kpi(rot,val,nota,dest){
  var d=el("div","kpi"+(dest?" dest":""));
  d.appendChild(el("div","r",rot)); d.appendChild(el("div","v",val));
  if(nota) d.appendChild(el("div","n",nota));
  return d;
}
/* ---------------- exportação ---------------- */
function hojeIso(){ var d=new Date();
  return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"); }
function csvNum(v){ if(v==null||v==="") return ""; if(typeof v!=="number") return String(v);
  return String(v).replace(".", ","); }
function csvTexto(linhas){
  /* ponto e vírgula e BOM: é como o Excel em português abre sem pedir nada */
  return "\ufeff"+linhas.map(function(l){
    return l.map(function(c){
      var v = c==null? "" : String(c);
      return /[";\r\n]/.test(v) ? '"'+v.replace(/"/g,'""')+'"' : v;
    }).join(";");
  }).join("\r\n");
}
function baixaArquivoLocal(nome,txt){
  try{
    var bl=new Blob([txt],{type:"text/csv;charset=utf-8"});
    var a=document.createElement("a");
    a.href=URL.createObjectURL(bl); a.download=nome;
    document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(a.href); if(a.parentNode) a.parentNode.removeChild(a); },300);
    return true;
  }catch(e){ return false }
}
/* no arquivo aberto no navegador o link basta; na página publicada quem entrega
   o arquivo é a capability de download, e o visitante confirma antes de salvar */
function baixaCsv(nome,linhas){
  var txt=csvTexto(linhas);
  if(window.claude && typeof window.claude.use==="function"){
    window.claude.use("downloads").then(function(d){
      if(d && d.save) return d.save({filename:nome, data:txt});
      if(!baixaArquivoLocal(nome,txt)) alert("Esta página não consegue entregar arquivos aqui.");
    }).catch(function(e){
      var c=(e&&e.code)||"";
      if(c==="declined") return;
      if(c==="rate_limited") alert("Já há um download aguardando confirmação. Tente de novo em instantes.");
      else if(!baixaArquivoLocal(nome,txt)) alert("Não consegui entregar o arquivo: "+(c||"motivo desconhecido"));
    });
    return;
  }
  if(!baixaArquivoLocal(nome,txt)) alert("Não consegui gerar o arquivo neste navegador.");
}
/* o botão exporta o que está filtrado, não a lista inteira */
function botaoExport(seletorDir,nome,fn){
  var d=$(seletorDir); if(!d) return;
  var h=d.parentNode;
  var velho=h.querySelector(".bt-exp"); if(velho && velho.parentNode) velho.parentNode.removeChild(velho);
  var b=el("button","bt mini bt-exp","Exportar CSV"); b.type="button";
  b.style.marginLeft="10px";
  b.title="Baixa em CSV exatamente o que está na lista agora, com os filtros aplicados";
  b.onclick=function(){ baixaCsv(nome+"-"+hojeIso()+".csv", fn()) };
  h.appendChild(b);
}
function avisoEl(cls,ico,tit,txt){
  var a=el("div","aviso "+cls);
  a.appendChild(el("div","ico",ico));
  var c=el("div"); c.style.minWidth="0"; c.appendChild(el("b",null,tit)); c.appendChild(el("p",null,txt));
  a.appendChild(c); return a;
}
function pintaGeral(){
  var L0=(BASE && BASE.lojistas)||[];
  var nAlvo=L0.filter(function(x){return x.at && (x.perf==="vestuario"||x.perf==="geral") && x.tel}).length;
  var tb=statTabela();
  var novos = LIVE.fila ? LIVE.fila.filter(function(l){return l.status==="novo"||l.status==="triagem"}).length : null;
  var nped = LIVE.pedidos ? LIVE.pedidos.length : null;

  /* o que trava a abertura: no máximo três, o resto fica na Conformidade */
  var trava=[];
  if(tb && tb.semDesconto) trava.push(["cri","Preço de lojista igual ao de varejo",
    "A lista \u201c"+tb.nome+"\u201d está com 0% e nenhum preço fixo"+(tb.medidoEm?" (medida em "+tb.medidoEm+")":"")+".",
    "Definir o fator na Shopify"]);
  if(LIVE.catalogo){
    var nQ=0,nC=0;
    (LIVE.catalogo.products?LIVE.catalogo.products.nodes:[]).forEach(function(p){
      var g=grade(p), ks=Object.keys(g.cores);
      nC+=ks.length; nQ+=ks.filter(function(c){return g.cores[c].quebrada}).length;
    });
    if(nQ) trava.push(["ate","Grade quebrada em "+inteiro(nQ)+" de "+inteiro(nC)+" cores",
      "Cor sem peça em algum tamanho da corrida não fecha grade e não é ofertável.",
      "Ver em Produto e preço"]);
  }
  if(!REGUA) trava.push(["ate","Régua de desconto do varejo não definida",
    "Sem ela a camada do meio não existe.", "Definir em Produto e preço"]);
  if(ERRO.fila) trava.unshift(["cri","A fila de cadastro não está chegando",
    "Sem ela você não vê quem pediu acesso.", "Clicar em Atualizar"]);

  var est=$("#estado-canal");
  if(est){
    est.textContent = trava.length
      ? "Canal em pré-lançamento · "+trava.length+(trava.length===1?" item trava":" itens travam")+" a abertura."
      : "Canal em pré-lançamento · nada travando a abertura no que esta página consegue ver.";
  }

  var av=limpa($("#avisos"));
  trava.slice(0,3).forEach(function(t){
    var a=avisoEl(t[0],"",t[1],t[2]);
    var p=a.querySelector("p");
    if(p && t[3]){ var b=el("b",null," → "+t[3]); b.style.cssText="font-weight:600;color:var(--tinta)"; p.appendChild(b); }
    av.appendChild(a);
  });
  if(trava.length>3){
    var m=el("p","nota","Mais "+(trava.length-3)+" na aba Conformidade."); av.appendChild(m);
  }

  var b2=baseNum();
  var g=limpa($("#kpis-geral"));
  g.appendChild(kpi("Alvo de reativação", inteiro(nAlvo), "ativo na Receita, no ramo e com telefone", true));
  g.appendChild(kpi("Lojistas aprovados", LIVE.empresas?inteiro(LIVE.empresas.length):"—", "empresas em b2b.companies"));
  g.appendChild(kpi("Referências no catálogo", LIVE.catalogo?inteiro(LIVE.catalogo.productsCount?LIVE.catalogo.productsCount.count:LIVE.catalogo.products.nodes.length):"—", "coleção de atacado"));
  g.appendChild(kpi("Pedidos B2B", nped==null?"—":inteiro(nped), "registrados no b2b.orders"));

  pintaRetornos();
  pintaEtapas();
}
/* a outra metade do trabalho do dia: quem tem retorno marcado para hoje ou atrasado */
function pintaRetornos(){
  var c=$("#retornos-corpo"); if(!c) return;
  limpa(c);
  var L0=(BASE && BASE.lojistas)||[];
  var hoje=hojeIso2();
  var dev=L0.filter(function(x){
    var p=PROSP[x.cnpj]||{};
    return p.prox && p.prox<=hoje;
  }).sort(function(a,b){ return ((PROSP[a.cnpj]||{}).prox||"").localeCompare((PROSP[b.cnpj]||{}).prox||"") });
  if(!dev.length) return;
  var h=el("div","sub-cab", dev.length===1? "1 retorno de prospecção para hoje" : inteiro(dev.length)+" retornos de prospecção para hoje");
  c.appendChild(h);
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Lojista","Praça","Contato","Marcado para","Estado","Ação"]));
  var tb=el("tbody");
  dev.slice(0,12).forEach(function(x){
    var p=PROSP[x.cnpj]||{};
    var tr=el("tr");
    var nm=el("button","lim nome",titulo(x.nome)||"—"); nm.type="button";
    nm.style.cssText="background:none;border:0;padding:0;font:inherit;font-weight:600;color:var(--ac);text-align:left;cursor:pointer";
    nm.onclick=function(){ if(window.vai) window.vai("base");
      var q=$("#f-q"); if(q){ q.value=cnpjBr(x.cnpj); q.dispatchEvent(new Event("input",{bubbles:true})); } };
    tr.appendChild(tdNode(nm));
    tr.appendChild(td(titulo(x.mun||x.cidade)+((x.ufr||x.uf)?" / "+(x.ufr||x.uf):"")));
    tr.appendChild(tdNode(el("span","mono", x.tel?telBr(x.tel):"—")));
    var r=rotuloAgenda(p.prox);
    tr.appendChild(tdNode(tagEl(r?r.txt:dataBr(p.prox), r?r.cls:"")));
    tr.appendChild(tdNode(tagEl((ESTADOS[p.estado]||{}).rot||"não trabalhado",(ESTADOS[p.estado]||{}).cls||"")));
    var tdA=el("td","acao");
    if(x.wa){ var a=el("a","bt mini","WhatsApp"); a.href="https://wa.me/"+x.wa; a.target="_blank"; a.rel="noopener";
      a.style.textDecoration="none"; tdA.appendChild(a); }
    tr.appendChild(tdA);
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); c.appendChild(env);
  if(dev.length>12){
    var n=el("div","sub-pe","e mais "+(dev.length-12)+" — ver em Lojistas, filtro de agenda");
    c.appendChild(n);
  }
}
function pintaEtapas(){
  var tb=statTabela();
  var itens=[
    ["Cadastro de lojista no ar", true, "Formulário publicado, gravando no Supabase"],
    ["Catálogo de atacado montado", !!(LIVE.catalogo && (LIVE.catalogo.productsCount?LIVE.catalogo.productsCount.count:0)>1),
      LIVE.catalogo? (LIVE.catalogo.productsCount?LIVE.catalogo.productsCount.count:0)+" referências publicadas" : "não lido"],
    ["Preço de lojista valendo", !!(tb && !tb.semDesconto), tb? (tb.semDesconto? "tabela com 0% e sem preço fixo em "+tb.medidoEm : "desconto aplicado") : "não lido"],
    ["Fila de cadastro no painel", !ERRO.fila && !!LIVE.fila, ERRO.fila? "leitura falhou" : "lendo do Supabase"],
    ["Régua de quantidade do varejo", !!REGUA, REGUA? reguaAtual().faixas.length+" faixas definidas" : "a definir"],
    ["Frete próprio do atacado", false, "pedido acima de R$ 300 ainda sai com frete grátis do varejo"],
    ["Primeiro pedido real de ponta a ponta", false, "não feito"]
  ];
  var n=itens.filter(function(i){return i[1]}).length;
  $("#etapas-resumo").textContent = n+" de "+itens.length+" prontas";
  var p=limpa($("#etapas"));
  var bar=el("div","barra"); var i2=el("i"); i2.style.width=Math.round(n/itens.length*100)+"%"; bar.appendChild(i2);
  p.appendChild(bar);
  var dl=el("dl"); dl.style.marginTop="12px";
  itens.forEach(function(it){
    var r=el("div","etapa");
    var dt=el("dt"); dt.appendChild(document.createTextNode(it[0]));
    var sm=el("small"); sm.style.color="var(--tinta-3)"; sm.style.display="block"; sm.style.fontSize="12px"; sm.textContent=it[2];
    dt.appendChild(sm); r.appendChild(dt);
    var dd=el("dd"); dd.appendChild(tagEl(it[1]?"Pronto":"Pendente", it[1]?"v":"a")); r.appendChild(dd);
    dl.appendChild(r);
  });
  p.appendChild(dl);
}

/* ================= FILA ================= */
var ST_FILA={novo:"Novo", triagem:"Em triagem", aprovado:"Aprovado", rejeitado:"Recusado",
             duplicado:"Duplicado", abandonado:"Abandonado"};
/* lead que abriu o formulário e não preencheu nada: não é informação, é ruído na lista */
function filaVazio(l){
  return !(l.empresa||"").trim() && !(l.cnpj||"").trim() && !(l.nome||"").trim() &&
         !(l.telefone||"").trim() && !(l.email||"").trim();
}
function pintaFila(){
  var c=limpa($("#fila-corpo"));
  if(ERRO.fila || !LIVE.fila){
    contador("fila",null);
    $("#fila-dir").textContent="leitura falhou";
    var v=el("div","vazio");
    v.appendChild(el("b",null,"Não consegui ler a fila"));
    v.appendChild(el("p",null,"O banco não respondeu. Pode ser falta de internet ou a sessão ter expirado. Clique em Atualizar para tentar de novo."));
    c.appendChild(v); return;
  }
  if(!LIVE.fila.length){
    contador("fila",null);
    $("#fila-dir").textContent="vazio";
    var v0=el("div","vazio");
    v0.appendChild(el("b",null,"Nenhum cadastro na fila"));
    v0.appendChild(el("p",null,"A leitura funcionou e não há lead nenhum em b2b.leads. Quando um lojista preencher o formulário de cadastro, ele aparece aqui."));
    c.appendChild(v0); return;
  }
  var q=($("#f-fila-q").value||"").toLowerCase(), st=$("#f-fila-st").value;
  var verVazio=$("#f-fila-vazio")?$("#f-fila-vazio").checked:false;
  var nVazios=LIVE.fila.filter(filaVazio).length;
  var L=LIVE.fila.filter(function(l){
    if(!verVazio && filaVazio(l)) return false;
    if(st && l.status!==st) return false;
    if(!q) return true;
    return (l.empresa+" "+l.cnpj+" "+l.cidade+" "+l.nome+" "+l.email).toLowerCase().indexOf(q)>=0;
  });
  contador("fila", LIVE.fila.filter(function(l){return l.status==="novo"||l.status==="triagem"}).length || null);
  var org = LIDO_EM ? ("lido às "+LIDO_EM) : "";
  $("#fila-dir").textContent = L.length+" de "+LIVE.fila.length+(org? " · "+org:"")+
    (nVazios&&!verVazio? " · "+nVazios+" em branco oculto"+(nVazios>1?"s":""):"")+
    "";
  botaoExport("#fila-dir","fila-de-cadastro",function(){
    var r=[["Entrou","Razão social","CNPJ","Contato","Telefone","E-mail","Cidade","UF","Status"]];
    L.forEach(function(l){ r.push([dataBr(l.criado), l.empresa||"", l.cnpj||"", l.nome||"",
      l.telefone||"", l.email||"", l.cidade||"", l.uf||"", ST_FILA[l.status]||l.status||""]) });
    return r;
  });
  if(!L.length){ c.appendChild(el("div","vazio")).appendChild(el("b",null,"Nada com esse filtro")); return; }
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Entrou","Razão social","CNPJ","Contato","Praça","Status","Ação"]));
  var tb=el("tbody");
  L.forEach(function(l){
    var tr=el("tr");
    tr.appendChild(td(dataBr(l.criado)));
    if(filaVazio(l)){
      var tv=el("td"); tv.colSpan=4;
      var ev=el("span",null,"Formulário aberto e abandonado sem preencher nada");
      ev.style.cssText="color:var(--tx3);font-style:italic";
      tv.appendChild(ev); tr.appendChild(tv);
    } else {
      tr.appendChild(td(l.empresa||"—"));
      tr.appendChild(tdMono(l.cnpj? cnpjBr(l.cnpj) : "—"));
      var p=el("div","pilha"); p.appendChild(document.createTextNode(l.nome||"—"));
      if(l.telefone) p.appendChild(el("small",null,telBr(l.telefone)));
      if(l.email) p.appendChild(el("small",null,l.email));
      tr.appendChild(tdNode(p));
      tr.appendChild(td((l.cidade||"—")+(l.uf?" / "+l.uf:"")));
    }
    var stc = l.status==="aprovado"?"v" : (l.status==="rejeitado"||l.status==="duplicado")?"r" : l.status==="triagem"?"a":"i";
    var pil=el("div","pilha"); pil.appendChild(tagEl(ST_FILA[l.status]||l.status, stc));
    if(l.status==="aprovado" && l.provisionado===false) pil.appendChild(el("small",null,"sem empresa na Shopify"));
    if(PEND[l.lead_id]) pil.appendChild(el("small",null,"aprovando…"));
    tr.appendChild(tdNode(pil));
    var acc=el("div"); acc.style.display="flex"; acc.style.gap="5px"; acc.style.flexWrap="wrap";
    if(PEND[l.lead_id]){
      acc.appendChild(el("span","tag a","na fila"));
    } else if(l.status==="novo"||l.status==="triagem"){
      acc.appendChild(botaoFila(l,"aprovado","Aprovar","bt mini ok"));
      acc.appendChild(botaoFila(l,"triagem","Pedir documento","bt mini"));
      acc.appendChild(botaoFila(l,"rejeitado","Recusar","bt mini mau"));
      acc.appendChild(botaoFila(l,"duplicado","Duplicado","bt mini"));
    } else {
      acc.appendChild(botaoFila(l,"novo","Reabrir","bt mini"));
    }
    tr.appendChild(tdNode(acc));
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); c.appendChild(env);
}
function botaoFila(l,novo,rot,cls){
  var b=el("button",cls,rot); b.type="button";
  b.onclick=function(){
    b.disabled=true; b.textContent="…";
    acaoFila(l,novo).then(function(ok){
      b.textContent = ok? "feito" : "falhou";
      if(!ok) b.className="bt mini mau";
    });
  };
  return b;
}
function acaoFila(l,novo){ return Promise.resolve(soLeitura()) }
function acaoFilaMake(l,novo){
  var agoraIso = new Date().toISOString();
  if(novo==="aprovado"){
    return Promise.reject({lead_id:l.lead_id, dono:"comercial",
                         aprovador:"Central de Comando", send_welcome:"true"})
      .then(function(d){ if(d && d.ok){ l.status="aprovado"; l.provisionado=true; pintaFila(); pintaGeral(); return true; } return false; })
      .catch(function(){ return false });
  }
  return Promise.reject({lead_id:l.lead_id, status:novo, acao:novo,
                       obs:"", motivo:"", pendencia:"", autor:"Central de Comando", em:agoraIso})
    .then(function(d){ if(d && d.ok){ l.status=novo; pintaFila(); pintaGeral(); return true; } return false; })
    .catch(function(){ return false });
}

/* ================= LOJISTAS ================= */
function pintaLojistas(){
  if(!$("#loj-corpo")) return;
  var c0=limpa($("#loj-corpo")); var c=c0;
  if(!LIVE.empresas){
    contador("lojistas",null);
    $("#loj-dir").textContent = ERRO.empresas? "Shopify não respondeu" : "";
    var v=el("div","vazio");
    v.appendChild(el("b",null, ERRO.empresas? "Não consegui ler as empresas":"Consultando a Shopify…"));
    if(ERRO.empresas) v.appendChild(el("p",null,"O conector da Shopify não respondeu a consulta de empresas B2B. Abra a Central de novo ou confira se o conector está ligado na sua conta."));
    c.appendChild(v); return;
  }
  contador("lojistas", LIVE.empresas.length||null);
  $("#loj-dir").textContent = LIVE.empresas.length+" empresa"+(LIVE.empresas.length===1?"":"s")+" · b2b.companies";
  if(!LIVE.empresas.length){
    var v2=el("div","vazio");
    v2.appendChild(el("b",null,"Nenhum lojista aprovado ainda"));
    v2.appendChild(el("p",null,"Quando você aprovar um cadastro na fila, a empresa aparece aqui com localização, condição de pagamento e histórico de compra."));
    c.appendChild(v2); return;
  }
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Empresa","Praça","Tabela / prazo","Dono","Pedidos","Comprou","Aprovada"]));
  var tb=el("tbody");
  LIVE.empresas.forEach(function(e){
    var tr=el("tr");
    var p=el("div","pilha");
    p.appendChild(lim(titulo(e.razao_social||e.nome_fantasia),"nome"));
    if(e.cnpj) p.appendChild(el("small","mono",cnpjBr(e.cnpj)));
    tr.appendChild(tdNode(p));
    tr.appendChild(tdNode(lim(titulo(e.cidade)+(e.uf?" / "+e.uf:""),"praca")));
    var c=el("div","pilha");
    c.appendChild(document.createTextNode(e.tabela||"—"));
    if(e.prazo) c.appendChild(el("small",null,e.prazo));
    tr.appendChild(tdNode(c));
    tr.appendChild(td(e.dono||"—"));
    tr.appendChild(tdD(inteiro(e.pedidos_count||0)));
    tr.appendChild(tdD(moeda(Number(e.receita_total)||0)));
    tr.appendChild(td(dataBr(e.aprovado_em||e.created_at)));
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); c0.appendChild(env);
}

/* ================= PEDIDOS ================= */
function pintaPedidos(){
  if(!$("#ped-corpo")) return;
  var c=limpa($("#ped-corpo"));
  if(!LIVE.pedidos){ c.appendChild(el("div","carregando","Consultando…")); return; }
  var L=LIVE.pedidos;
  contador("ped", L.length||null);
  $("#ped-dir").textContent = L.length+" pedido"+(L.length===1?"":"s")+" · b2b.orders";
  if(!L.length){
    var v=el("div","vazio");
    v.appendChild(el("b",null,"Nenhum pedido de atacado ainda"));
    v.appendChild(el("p",null,"A tabela b2b.orders está vazia. O primeiro pedido real de ponta a ponta continua pendente."));
    c.appendChild(v); return;
  }
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Pedido","Data","Peças","Valor","Margem","Pagamento","Fiscal","Logística"]));
  var tb=el("tbody");
  L.forEach(function(o){
    var tr=el("tr");
    tr.appendChild(tdMono(o.order_name||"—"));
    tr.appendChild(td(dataBr(o.pedido_em||o.created_at)));
    tr.appendChild(tdD(inteiro(o.pecas)));
    tr.appendChild(tdD(moeda(Number(o.valor_liquido)||0)));
    tr.appendChild(tdD(o.margem_pct!=null? pct(Number(o.margem_pct)) : "—"));
    tr.appendChild(tdNode(tagEl(o.status_pagamento||"—", o.status_pagamento==="pago"?"v":"a")));
    tr.appendChild(tdNode(tagEl(o.status_fiscal||"—","")));
    tr.appendChild(tdNode(tagEl(o.status_logistico||"—","")));
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); c.appendChild(env);
}

/* ---- helpers de tabela ---- */
var DIR=/^(Peças|Valor|Pedidos|Comprou|Estoque|Preço|Cores|Anos|Clientes|Folga|Margem|Ativos|Inativos|%|Desconto|A partir)/;
var FIXA=/^(Prospecção|Ação|Corte|Remover)$/;
/* cfg opcional: {chaves:{"Rótulo":"chave"}, k:"chave atual", d:1|-1, aplica:function(k,d){}} */
function cabecalho(cols,cfg){
  var th=el("thead"), tr=el("tr");
  cols.forEach(function(c){
    var h=el("th",null,"");
    h.setAttribute("scope","col");
    if(FIXA.test(c)) h.className="acao";
    else if(DIR.test(c)) h.className="d";
    var chave = cfg && cfg.chaves ? cfg.chaves[c] : null;
    if(chave){
      var b=el("button","thbt"); b.type="button";
      b.appendChild(document.createTextNode(c));
      var seta=el("i","seta"); b.appendChild(seta);
      var ativo = cfg.k===chave;
      h.setAttribute("aria-sort", ativo ? (cfg.d>0?"ascending":"descending") : "none");
      if(ativo){ h.classList.add("ord"); seta.textContent = cfg.d>0 ? "\u2191" : "\u2193"; }
      b.title = ativo ? ("Ordenado por "+c+" — clique para inverter")
                      : ("Ordenar por "+c);
      b.onclick=function(){ cfg.aplica(chave, ativo ? -cfg.d : (DIR.test(c)? -1 : 1)) };
      h.appendChild(b);
    } else {
      h.appendChild(document.createTextNode(c));
    }
    tr.appendChild(h);
  });
  th.appendChild(tr); return th;
}
/* leitor de tela: anuncia contagem de resultado e efeito de ação em lote */
function anuncia(txt){
  var a=$("#anuncio"); if(!a) return;
  a.textContent="";
  setTimeout(function(){ a.textContent=txt },40);
}
/* Caixa alta do cadastro antigo vira caixa de título, para a coluna não gritar. */
var MIN=["de","da","do","das","dos","e","em","a","o"];
function titulo(t){
  t=String(t||"").trim();
  if(!t) return "";
  if(t!==t.toUpperCase()) return t;
  return t.split(/\s+/).map(function(p,i){
    var b=p.toLowerCase();
    if(i>0 && MIN.indexOf(b)>=0) return b;
    if(/^(ltda|me|epp|sa|s\/a|eireli|cia|ind|com)$/.test(b)) return b.toUpperCase();
    if(p.length<=3) return p.toUpperCase();
    return b.charAt(0).toUpperCase()+b.slice(1);
  }).join(" ");
}
function lim(txt,cls,dica){
  var s=el("span","lim"+(cls?" "+cls:""),txt||"—");
  if(dica||txt) s.title = dica||txt||"";
  return s;
}
function td(x){ return el("td",null,x==null?"—":String(x)) }
function tdD(x){ return el("td","d",x==null?"—":String(x)) }
function tdMono(x){ var c=el("td"); var s=el("span","mono",x==null?"—":String(x)); c.appendChild(s); return c }
function tdNode(n){ var c=el("td"); c.appendChild(n); return c }

/* ================= BASE HISTÓRICA ================= */
var basePag=0, BASE_POR=60;
var SEL={};   /* cnpj -> true, seleção para ação em lote */
/* direção padrão de cada chave de ordenação; o clique no cabeçalho inverte */
var ORD_PADRAO={vr:-1, ult:-1, pc:-1, ped:-1, nome:1, uf:1, ag:1};
var baseDir=null, catDir=null;
var repOrd={k:"vr", d:-1};
function dirDe(k,forcada){ return forcada!=null ? forcada : (ORD_PADRAO[k]||1) }
function selN(){ return Object.keys(SEL).length }
function selLimpa(){ SEL={} }
function hojeIso2(){ var d=new Date();
  return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"); }
function diasAte(iso){
  if(!iso) return null;
  var h=hojeIso2();
  var a=new Date(iso+"T00:00:00"), b=new Date(h+"T00:00:00");
  return Math.round((a-b)/86400000);
}
function rotuloAgenda(iso){
  var d=diasAte(iso); if(d===null) return null;
  if(d<0) return {txt:"atrasado "+(-d)+(d===-1?" dia":" dias"), cls:"r"};
  if(d===0) return {txt:"retorno hoje", cls:"a"};
  if(d===1) return {txt:"retorno amanhã", cls:"i"};
  return {txt:"retorno "+dataBr(iso), cls:""};
}
function baseFiltrada(){
  var q=($("#f-q").value||"").toLowerCase().replace(/[.\/-]/g,"");
  var uf=$("#f-uf").value, tp=$("#f-tipo").value, es=$("#f-est").value;
  var st=$("#f-sit")?$("#f-sit").value:"", pf=$("#f-perf")?$("#f-perf").value:"";
  var soTel=$("#f-tel").checked, soH=$("#f-hist").checked, ord=$("#f-ord").value;
  var ag=$("#f-agenda")?$("#f-agenda").value:"";
  var eg=$("#f-est2")?$("#f-est2").value:"";
  var L=(BASE.lojistas||[]).filter(function(x){
    if(uf && (x.uf||"")!==uf) return false;
    if(tp && x.tipo!==tp) return false;
    if(st==="at" && !x.at) return false;
    if(st==="in" && x.at) return false;
    if(st==="alvo" && !(x.at && (x.perf==="vestuario"||x.perf==="geral") && x.tel)) return false;
    if(pf && (x.perf||"")!==pf) return false;
    if(soTel && !x.tel) return false;
    if(soH && !x.ped) return false;
    if(es){
      var e=(PROSP[x.cnpj]||{}).estado||"";
      if(es==="__novo"){ if(e) return false } else if(e!==es) return false;
    }
    if(eg && estagio(x).k!==eg) return false;
    if(ag){
      var px=(PROSP[x.cnpj]||{}).prox||"";
      if(ag==="sem"){ if(px) return false }
      else if(ag==="marcado"){ if(!px) return false }
      else {
        if(!px) return false;
        var dd=diasAte(px);
        if(ag==="hoje" && dd>0) return false;
        if(ag==="atras" && dd>=0) return false;
      }
    }
    if(q){
      var alvo=(x.nome+" "+x.cnpj+" "+x.cidade+" "+x.contato+" "+x.email+" "+x.rep).toLowerCase().replace(/[.\/-]/g,"");
      if(alvo.indexOf(q)<0) return false;
    }
    return true;
  });
  var k=ord||"vr", d=dirDe(k,baseDir);
  L.sort(function(a,b){
    var r=0;
    if(k==="ag"){
      var pa=(PROSP[a.cnpj]||{}).prox||"9999-99-99", pb=(PROSP[b.cnpj]||{}).prox||"9999-99-99";
      r=pa.localeCompare(pb);
      if(r) return r*d;
      return (b.vr||0)-(a.vr||0);
    }
    if(k==="nome")      r=(a.nome||"").localeCompare(b.nome||"","pt");
    else if(k==="uf")   r=((a.uf||"zz")+(a.cidade||"")).localeCompare((b.uf||"zz")+(b.cidade||""),"pt");
    else if(k==="pc")   r=(a.pc||0)-(b.pc||0);
    else if(k==="ped")  r=(a.ped||0)-(b.ped||0);
    else if(k==="ult")  r=String(a.ult||"").localeCompare(String(b.ult||""));
    else                r=(a.vr||0)-(b.vr||0);
    return r*d;
  });
  return L;
}
function pintaBase(){
  if(!BASE.lojistas.length) return;
  var b=baseNum(), k=limpa($("#kpis-base2"));
  var L0=BASE.lojistas||[];
  var nAt=L0.filter(function(x){return x.at}).length;
  var nAlvo=L0.filter(function(x){return x.at && (x.perf==="vestuario"||x.perf==="geral") && x.tel}).length;
  k.appendChild(kpi("CNPJ na base", inteiro(b.total), inteiro(b.tel)+" com telefone · "+inteiro(b.email)+" com e-mail"));
  k.appendChild(kpi("Ativos na Receita", inteiro(nAt), inteiro(b.total-nAt)+" baixados, inaptos ou suspensos"));
  k.appendChild(kpi("Alvo de reativação", inteiro(nAlvo), "ativo, ainda no ramo e com telefone", true));
  k.appendChild(kpi("Já trabalhados", inteiro(b.trab), b.trab? "com estado de prospecção":"marque o estado na lista"));
  var agVence=0, agMarc=0;
  Object.keys(PROSP).forEach(function(c){
    var px=PROSP[c].prox; if(!px) return; agMarc++;
    if(diasAte(px)<=0) agVence++;
  });
  k.appendChild(kpi("Retornos para hoje", inteiro(agVence),
    agMarc? (inteiro(agMarc)+" com data marcada") : "nenhuma data marcada ainda", agVence>0));

  var sel=$("#f-uf");
  if(sel.options.length<=1){
    var ufs={}; BASE.lojistas.forEach(function(x){ ufs[x.uf||""]=(ufs[x.uf||""]||0)+1 });
    Object.keys(ufs).filter(function(u){return u}).sort().forEach(function(u){
      var o=el("option",null,u+" ("+ufs[u]+")"); o.value=u; sel.appendChild(o);
    });
  }
  var L=baseFiltrada();
  contador("base", L.length);
  $("#base-dir").textContent = inteiro(L.length)+" de "+inteiro(BASE.lojistas.length);
  botaoExport("#base-dir","base-historica",function(){
    var r=[["Razão social","CNPJ","Município","UF","Cidade no cadastro","UF no cadastro",
      "Situação na Receita","Motivo","Desde","Ramo hoje","CNAE","Razão social hoje","Porte","Simples",
      "Contato","Telefone","E-mail","Pedidos","Peças","Valor","Primeiro pedido","Último pedido",
      "Representante","Tipo no histórico","Teto de 20 pedidos","Estado de prospecção","Nota"]];
    L.forEach(function(x){
      var pr=PROSP[x.cnpj]||{};
      r.push([x.nome||"", cnpjBr(x.cnpj), x.mun||"", x.ufr||"", x.cidade||"", x.uf||"",
        SITS[x.sit]||x.sit||"", x.mot||"", dataBr(x.dsd), PERFIS[x.perf]||"", x.cnae||"", x.rfnome||"",
        x.prt||"", x.smp||"", x.contato||"", x.tel?telBr(x.tel):"", x.email||"",
        csvNum(x.ped||0), csvNum(x.pc||0), csvNum(x.vr||0), dataBr(x.pri), dataBr(x.ult),
        x.rep||"", (TIPOS[x.tipo]||TIPOS.outro).rot, x.teto?"sim":"não",
        (ESTADOS[pr.estado]||{}).rot||"", pr.nota||""]);
    });
    return r;
  });
  var tot=Math.max(1,Math.ceil(L.length/BASE_POR));
  if(basePag>=tot) basePag=0;
  var fat=L.slice(basePag*BASE_POR,(basePag+1)*BASE_POR);
  var c=limpa($("#base-corpo"));
  barraSelecao(L,fat);
  if(!L.length){
    var v=el("div","vazio"); v.appendChild(el("b",null,"Nenhum lojista com esses filtros"));
    v.appendChild(el("p",null,"Afrouxe um dos filtros — situação na Receita, ramo, estado de prospecção ou agenda de retorno — ou limpe a busca."));
    var bz=el("button","bt mini","Limpar todos os filtros"); bz.type="button"; bz.style.marginTop="12px";
    bz.onclick=function(){
      ["f-q","f-uf","f-tipo","f-sit","f-perf","f-est","f-agenda"].forEach(function(id){ var e=$("#"+id); if(e) e.value="" });
      ["f-tel","f-hist"].forEach(function(id){ var e=$("#"+id); if(e) e.checked=false });
      basePag=0; pintaBase();
    };
    v.appendChild(bz);
    c.appendChild(v);
  } else {
    var env=el("div","tab-env"), t=el("table","larga");
    var kAtual=($("#f-ord").value||"vr");
    var cab=cabecalho(["","Razão social","Praça","Situação","Contato","Pedidos","Valor","Último pedido","Prospecção"],
      {chaves:{"Razão social":"nome","Praça":"uf","Pedidos":"ped","Valor":"vr","Último pedido":"ult"},
       k:kAtual, d:dirDe(kAtual,baseDir),
       aplica:function(k2,d2){ $("#f-ord").value=k2; baseDir=d2; basePag=0; pintaBase();
                               anuncia("Ordenado por "+k2+", "+(d2>0?"crescente":"decrescente")); }});
    var th0=cab.querySelector("th");
    th0.className="caixa";
    var tudo=el("input"); tudo.type="checkbox"; tudo.setAttribute("aria-label","Selecionar os desta página");
    tudo.checked = fat.length>0 && fat.every(function(x){ return SEL[x.cnpj] });
    tudo.onchange=function(){
      fat.forEach(function(x){ if(tudo.checked) SEL[x.cnpj]=true; else delete SEL[x.cnpj] });
      pintaBase();
    };
    th0.appendChild(tudo);
    t.appendChild(cab);
    var tb=el("tbody");
    fat.forEach(function(x){ tb.appendChild(linhaBase(x,tb)) });
    t.appendChild(tb); env.appendChild(t); c.appendChild(env);
  }
  var p=limpa($("#base-pag"));
  if(L.length>BASE_POR){
    var ant=el("button","bt mini","Anteriores"); ant.type="button"; ant.disabled=basePag===0;
    ant.onclick=function(){ basePag--; pintaBase() };
    var pro=el("button","bt mini","Próximos"); pro.type="button"; pro.disabled=basePag>=tot-1;
    pro.onclick=function(){ basePag++; pintaBase() };
    p.appendChild(ant); p.appendChild(pro);
    p.appendChild(el("span",null,"Página "+(basePag+1)+" de "+tot)).style.cssText="font-size:12.5px;color:var(--tinta-2)";
  }
}
/* barra que aparece quando há linha marcada: é o que faz 284 alvos virarem trabalho */
function barraSelecao(L,fat){
  var w=limpa($("#selbar"));
  var n=selN();
  w.hidden = !n;
  document.body.classList.toggle("com-selbar", !!n);
  if(!n) return w;
  var cnpjs=Object.keys(SEL);
  w.appendChild(el("b",null, n===1? "1 lojista selecionado" : inteiro(n)+" lojistas selecionados"));

  /* escopo explícito: a caixa do cabeçalho marca só a página; o filtro inteiro é escolha */
  var daPagina = fat.length && fat.every(function(x){ return SEL[x.cnpj] });
  if(daPagina && n<L.length){
    var esc=el("span","selesc");
    esc.appendChild(document.createTextNode("Só os "+inteiro(fat.length)+" desta página."));
    var todos=el("button","bt mini","Selecionar os "+inteiro(L.length)+" do filtro"); todos.type="button";
    todos.onclick=function(){ L.forEach(function(x){ SEL[x.cnpj]=true }); pintaBase();
                              anuncia(inteiro(L.length)+" lojistas selecionados") };
    esc.appendChild(todos);
    w.appendChild(esc);
  }

  var se=el("select"); se.setAttribute("aria-label","Marcar estado dos selecionados");
  se.appendChild(el("option",null,"Marcar estado…")).value="";
  Object.keys(ESTADOS).forEach(function(k){ var o=el("option",null,ESTADOS[k].rot); o.value=k; se.appendChild(o) });
  se.onchange=function(){
    if(!se.value) return;
    aplicaLote(cnpjs,{estado:se.value},"marcados como "+ESTADOS[se.value].rot.toLowerCase());
    se.value="";
  };
  w.appendChild(se);

  var dt=el("input"); dt.type="date"; dt.setAttribute("aria-label","Agendar retorno dos selecionados");
  dt.title="Agendar o próximo contato de todos os selecionados";
  dt.onchange=function(){
    if(!dt.value) return;
    aplicaLote(cnpjs,{prox:dt.value},"com retorno agendado para "+dataBr(dt.value));
    dt.value="";
  };
  w.appendChild(dt);

  var bt=el("button","bt mini","Registrar tentativa"); bt.type="button";
  bt.title="Soma 1 em tentativas de contato de cada selecionado";
  bt.onclick=function(){
    var antes=fotoProsp(cnpjs,{tent:0});
    cnpjs.forEach(function(c){ gravaProsp(c,{tent:((PROSP[c]||{}).tent||0)+1}) });
    var ok=salvaProspLote(cnpjs,{});
    toast(inteiro(ok)+" com tentativa registrada","Desfazer",function(){
      salvaProspLote(cnpjs,null,antes);
      toast("tentativas desfeitas",null,null,4000);
    });
  };
  w.appendChild(bt);

  var be=el("button","bt mini","Exportar seleção"); be.type="button";
  be.onclick=function(){
    var r=[["Razão social","CNPJ","Município","UF","Situação","Ramo hoje","Contato","Telefone","E-mail",
      "Pedidos","Valor","Último pedido","Estado","Próximo contato","Tentativas","Nota"]];
    L.filter(function(x){return SEL[x.cnpj]}).forEach(function(x){
      var p=PROSP[x.cnpj]||{};
      r.push([x.nome||"", cnpjBr(x.cnpj), x.mun||"", x.ufr||x.uf||"", SITS[x.sit]||x.sit||"",
        PERFIS[x.perf]||"", x.contato||"", x.tel?telBr(x.tel):"", x.email||"",
        csvNum(x.ped||0), csvNum(x.vr||0), dataBr(x.ult),
        (ESTADOS[p.estado]||{}).rot||"", p.prox?dataBr(p.prox):"", csvNum(p.tent||0), p.nota||""]);
    });
    baixaCsv("selecao-prospeccao-"+hojeIso()+".csv", r);
  };
  w.appendChild(be);

  var bl=el("button","bt mini","Limpar seleção"); bl.type="button";
  bl.onclick=function(){ selLimpa(); pintaBase(); anuncia("Seleção limpa") };
  w.appendChild(bl);

  var av=el("span","selmsg"); av.id="sel-msg"; w.appendChild(av);
  return w;
}
/* ação reversível: aplica e oferece desfazer, em vez de perguntar antes */
var toastT=null;
function toast(txt, rotAcao, acao, ms){
  var t=$("#toaste"); if(!t) return;
  limpa(t); t.hidden=false;
  t.appendChild(el("span",null,txt));
  if(acao){
    var b=el("button",null,rotAcao||"Desfazer"); b.type="button";
    b.onclick=function(){ escondeToast(); acao(); };
    t.appendChild(b);
  }
  var x=el("button",null,"\u2715"); x.type="button"; x.title="Fechar";
  x.style.cssText="text-decoration:none;font-weight:400;opacity:.7";
  x.onclick=escondeToast; t.appendChild(x);
  clearTimeout(toastT);
  toastT=setTimeout(escondeToast, ms||9000);
  anuncia(txt);
}
function escondeToast(){ var t=$("#toaste"); if(t){ t.hidden=true; limpa(t) } clearTimeout(toastT); }
/* guarda o valor anterior dos campos tocados, para o desfazer ser exato */
function fotoProsp(cnpjs, campos){
  var foto={};
  cnpjs.forEach(function(c){
    var a=PROSP[c]||{}, g={};
    Object.keys(campos).forEach(function(k){ g[k]= (k in a)? a[k] : (k==="tent"?0:"") });
    foto[c]=g;
  });
  return foto;
}
function aplicaLote(cnpjs, campos, descricao){
  var antes=fotoProsp(cnpjs, campos);
  var ok=salvaProspLote(cnpjs, campos);
  var n=cnpjs.length;
  var txt = (ok<n ? inteiro(ok)+" de "+inteiro(n)+" gravados — " : inteiro(n)+" ")+descricao;
  if(ok<n) txt += " (os demais não foram gravados)";
  toast(txt, "Desfazer", function(){
    var volta=salvaProspLote(cnpjs, null, antes);
    toast(inteiro(volta)+" "+(volta===1?"registro voltou":"registros voltaram")+" ao estado anterior", null, null, 5000);
  });
}
function recado(txt){
  var a=$("#sel-msg"); if(!a) return;
  a.textContent=txt;
  setTimeout(function(){ var b=$("#sel-msg"); if(b && b.textContent===txt) b.textContent="" },4000);
}
/* o mesmo CNPJ em três estágios: aprovado na Shopify, já comprou, nunca comprou */
var CNPJ_APROVADO=null;
function aprovados(){
  if(CNPJ_APROVADO) return CNPJ_APROVADO;
  CNPJ_APROVADO={};
  ((LIVE.empresas)||[]).forEach(function(e){
    var c=String((e&&(e.cnpj||e.taxId||e.externalId))||"").replace(/\D/g,"");
    if(c) CNPJ_APROVADO[c]=true;
  });
  return CNPJ_APROVADO;
}
function estagio(x){
  if(aprovados()[String(x.cnpj||"").replace(/\D/g,"")]) return {k:"aprovado", rot:"Aprovado", cls:"v"};
  if(x.ped) return {k:"comprou", rot:"Já comprou", cls:"i"};
  return {k:"nunca", rot:"Nunca comprou", cls:""};
}
function linhaBase(x,tb){
  var tr=el("tr");
  var tdc0=el("td","caixa");
  var cx=el("input"); cx.type="checkbox"; cx.checked=!!SEL[x.cnpj];
  cx.setAttribute("aria-label","Selecionar "+(x.nome||x.cnpj));
  cx.onchange=function(){
    if(cx.checked) SEL[x.cnpj]=true; else delete SEL[x.cnpj];
    tr.classList.toggle("marc", cx.checked);
    pintaBase();
  };
  tdc0.appendChild(cx); tr.appendChild(tdc0);
  tdc0.onclick=function(ev){ if(ev.target!==cx){ cx.checked=!cx.checked; cx.onchange(); } };
  if(SEL[x.cnpj]) tr.classList.add("marc");
  var nm=el("button","lim nome",titulo(x.nome)||"—"); nm.type="button"; nm.title=x.nome||"";
  nm.style.cssText="background:none;border:0;padding:0;font:inherit;font-weight:600;color:var(--navy);text-align:left;cursor:pointer";
  nm.onclick=function(){
    Array.prototype.forEach.call(document.querySelectorAll("tr.sel"),function(r){ r.classList.remove("sel") });
    tr.classList.add("sel");
    var praca=titulo(x.mun||x.cidade)+((x.ufr||x.uf)?" / "+(x.ufr||x.uf):"");
    var chips=[cnpjBr(x.cnpj)];
    if(praca.trim()&&praca.trim()!=="/") chips.push(praca);
    chips.push(seloSit(x));
    chips.push(tagEl(PERFIS[x.perf]||"—", x.perf==="vestuario"?"v":(x.perf==="fora"?"r":"")));
    window.abreGaveta(titulo(x.nome)||"—", chips, corpoBase(x));
  };
  var pn=el("div","pilha"); pn.appendChild(nm); pn.appendChild(el("small","mono",cnpjBr(x.cnpj)));
  tr.appendChild(tdNode(pn));
  var pr=el("div","pilha");
  pr.appendChild(lim(titulo(x.mun||x.cidade)+((x.ufr||x.uf)?" / "+(x.ufr||x.uf):""),"praca"));
  if(x.mud) pr.appendChild(el("small",null,"era "+titulo(x.cidade||"?")+"/"+(x.uf||"?")));
  tr.appendChild(tdNode(pr));
  var eg2=estagio(x);
  var ps=el("div","pilha");
  ps.appendChild(tagEl(eg2.rot, eg2.cls));
  var ss=seloSit(x);
  if(ss){ ss.style.fontSize="10.5px"; ps.appendChild(ss); }
  tr.appendChild(tdNode(ps));
  var pc=el("div","pilha");
  if(x.contato) pc.appendChild(lim(titulo(x.contato),"gente"));
  if(x.tel){
    var lt=el("div"); lt.style.cssText="display:flex;gap:6px;align-items:center";
    lt.appendChild(el("small","mono",telBr(x.tel)));
    if(x.wa){ var aw=el("a","tag i","WA"); aw.href="https://wa.me/"+x.wa; aw.target="_blank"; aw.rel="noopener";
      aw.style.textDecoration="none"; aw.title="Abrir conversa no WhatsApp com "+(x.contato||x.nome); lt.appendChild(aw); }
    pc.appendChild(lt);
  }
  if(!x.contato && !x.tel) pc.appendChild(document.createTextNode("—"));
  tr.appendChild(tdNode(pc));
  var cp=el("div","pilha"); cp.style.alignItems="flex-end";
  var l1=el("div"); l1.style.cssText="display:flex;gap:5px;align-items:center";
  l1.appendChild(document.createTextNode(x.ped? inteiro(x.ped)+" ped":"—"));
  if(x.teto){ var mt=el("span","tag a","+"); mt.title="Histórico maior que o mostrado: a consulta do sisfab devolve no máximo 20 pedidos por CNPJ."; l1.appendChild(mt); }
  cp.appendChild(l1);
  if(x.pc) cp.appendChild(el("small",null,inteiro(x.pc)+" peças"));
  tr.appendChild(tdNode(cp)).className="d";
  tr.appendChild(tdD(x.vr? moedaC(x.vr):"—"));
  var a=anos(x.ult);
  var cu=el("div","pilha");
  cu.appendChild(document.createTextNode(dataBr(x.ult)));
  if(a!=null) cu.appendChild(el("small",null, a===0? "este ano" : "há "+a+(a===1?" ano":" anos")));
  tr.appendChild(tdNode(cu));
  var cel=el("div","pilha"); cel.style.alignItems="flex-end";
  cel.appendChild(seletorProsp(x));
  var pr=PROSP[x.cnpj]||{};
  var rot=rotuloAgenda(pr.prox);
  if(rot){ var ch=tagEl(rot.txt,rot.cls); ch.title="Próximo contato em "+dataBr(pr.prox); cel.appendChild(ch); }
  if(pr.tent) cel.appendChild(el("small","mono",pr.tent+(pr.tent===1?" tentativa":" tentativas")));
  var tdp=tdNode(cel); tdp.className="acao"; tr.appendChild(tdp);
  return tr;
}
var PERFIS={vestuario:"Vestuário", geral:"Comércio geral", representante:"Representante", fora:"Fora do ramo"};
var SITS={"ATIVA":"Ativa","BAIXADA":"Baixada","INAPTA":"Inapta","SUSPENSA":"Suspensa","NAO ENCONTRADO":"Não encontrado"};
function seloSit(x){
  if(!x.sit) return tagEl("—","");
  if(x.at) return tagEl("Ativa","v");
  var rot = SITS[x.sit] || (x.sit.charAt(0)+x.sit.slice(1).toLowerCase());
  var t = tagEl(rot, x.sit==="INAPTA"?"a":"r");
  t.title = (x.mot||"") + (x.dsd? " · desde "+dataBr(x.dsd) : "");
  return t;
}
function seletorProsp(x){
  var wrap=el("div"); wrap.style.display="flex"; wrap.style.gap="6px"; wrap.style.alignItems="center"; wrap.style.justifyContent="flex-end";
  var s=el("select"); s.setAttribute("aria-label","Estado de prospecção de "+(x.nome||x.cnpj));
  s.style.fontSize="12px"; s.style.padding="3px 6px";
  var o0=el("option",null,"—"); o0.value=""; s.appendChild(o0);
  Object.keys(ESTADOS).forEach(function(k){ var o=el("option",null,ESTADOS[k].rot); o.value=k; s.appendChild(o) });
  s.value=(PROSP[x.cnpj]||{}).estado||"";
  s.onchange=function(){ salvaProsp(x.cnpj, s.value, (PROSP[x.cnpj]||{}).nota) };
  wrap.appendChild(s);
  return wrap;
}
function corpoBase(x){
  var box=el("div"); box.style.cssText="display:grid;gap:16px";
  var d1=el("dl");
  [["Primeiro pedido",dataBr(x.pri)],["Último pedido",dataBr(x.ult)],
   ["Representante",x.rep||"—"],["Cadastrado em",x.cadastro||"—"],
   ["E-mail",x.email||"—"],["Telefone",x.tel?telBr(x.tel):"—"],
   ["Tipo no histórico",(TIPOS[x.tipo]||TIPOS.outro).rot],
   ["Situação na Receita",(SITS[x.sit]||x.sit||"—")+(x.dsd? " desde "+dataBr(x.dsd):"")],
   ["Motivo",x.mot||"—"],
   ["Razão social hoje",x.rfnome||"—"],
   ["Atividade principal",x.cnae||"—"],
   ["Porte / Simples",(x.prt||"—")+(x.smp? " · Simples: "+x.smp:"")]].forEach(function(p){
    var r=el("div","par"); r.appendChild(el("dt",null,p[0])); r.appendChild(el("dd",null,p[1])); d1.appendChild(r);
  });
  box.appendChild(d1);
  var d2=el("div");
  d2.appendChild(el("div","r","Tabelas usadas")).style.cssText="font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--tinta-3);margin-bottom:5px";
  var tg=el("div"); tg.style.cssText="display:flex;gap:4px;flex-wrap:wrap";
  (x.tab||"").split("|").forEach(function(t){ if(t.trim()) tg.appendChild(tagEl(t.trim(),"")) });
  if(!tg.childNodes.length) tg.appendChild(el("span",null,"—"));
  d2.appendChild(tg);
  var l2=el("div","r","Condições de pagamento"); l2.style.cssText="font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--tinta-3);margin:11px 0 5px";
  d2.appendChild(l2);
  var cg=el("div"); cg.style.cssText="display:flex;gap:4px;flex-wrap:wrap";
  (x.cond||"").split("|").forEach(function(t){ if(t.trim()) cg.appendChild(tagEl(t.trim(),"c")) });
  if(!cg.childNodes.length) cg.appendChild(el("span",null,"—"));
  d2.appendChild(cg);
  box.appendChild(d2);
  var d3=el("div");
  d3.appendChild(el("div","r","Nota da prospecção")).style.cssText="font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--tinta-3);margin-bottom:5px";
  var ta=el("textarea"); ta.id="nota-"+x.cnpj; ta.rows=3;
  ta.style.cssText="width:100%;font:inherit;font-size:13px;padding:6px 8px;border:1px solid var(--linha-forte);border-radius:6px;background:var(--superficie);color:var(--tinta);resize:vertical";
  ta.value=(PROSP[x.cnpj]||{}).nota||"";
  ta.placeholder="Quem atendeu, o que ficou combinado, quando retornar…";
  d3.appendChild(ta);
  var lag=el("div","r","Próximo contato");
  lag.style.cssText="font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--tinta-3);margin:14px 0 5px";
  d3.appendChild(lag);
  var ag=el("div"); ag.style.cssText="display:flex;gap:8px;align-items:center;flex-wrap:wrap";
  var di=el("input"); di.type="date"; di.id="prox-"+x.cnpj;
  di.value=(PROSP[x.cnpj]||{}).prox||"";
  di.setAttribute("aria-label","Data do próximo contato");
  di.onchange=function(){ salvaProsp2(x.cnpj,{prox:di.value}); };
  ag.appendChild(di);
  [["Amanhã",1],["Em 7 dias",7],["Em 30 dias",30]].forEach(function(o){
    var bq=el("button","bt mini",o[0]); bq.type="button";
    bq.onclick=function(){
      var d=new Date(); d.setDate(d.getDate()+o[1]);
      var iso=d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");
      di.value=iso; salvaProsp2(x.cnpj,{prox:iso});
    };
    ag.appendChild(bq);
  });
  var bt2=el("button","bt mini","+1 tentativa"); bt2.type="button";
  var ct=el("span"); ct.style.cssText="font-family:var(--mn);font-size:11px;color:var(--tinta-3)";
  function pintaTent(){ var n=(PROSP[x.cnpj]||{}).tent||0; ct.textContent=n? n+(n===1?" tentativa":" tentativas") : "sem tentativa registrada" }
  pintaTent();
  bt2.onclick=function(){ salvaProsp2(x.cnpj,{tent:((PROSP[x.cnpj]||{}).tent||0)+1}); pintaTent(); };
  ag.appendChild(bt2); ag.appendChild(ct);
  d3.appendChild(ag);
  var bs=el("button","bt mini pri","Salvar nota"); bs.type="button"; bs.style.marginTop="14px";
  var av=el("span"); av.style.cssText="font-size:12px;color:var(--tinta-2);margin-left:8px";
  bs.onclick=function(){ var ok=salvaProsp(x.cnpj,(PROSP[x.cnpj]||{}).estado,ta.value); av.textContent= ok?"salvo":"não foi possível salvar"; };
  d3.appendChild(bs); d3.appendChild(av);
  if(x.teto){
    var n=el("p","nota","Este cliente aparece com 20 pedidos, que é o teto da consulta do sisfab. O histórico real é maior que o mostrado.");
    n.style.marginTop="10px"; d3.appendChild(n);
  }
  box.appendChild(d3);
  return box;
}

/* ================= REPRESENTANTES ================= */
function sitRep(r){
  var a=parseInt(String(r.ult||"").slice(0,4),10)||0;
  if(a>=2025) return {k:"ativo", rot:"Ativo hoje", cls:"v"};
  if(a>=2016) return {k:"recente", rot:"Saiu em "+a, cls:"a"};
  return {k:"antigo", rot:"Inativo desde "+(a||"s/d"), cls:""};
}
function pintaReps(){
  var R=REPS.representantes||[];
  if(!R.length) return;
  var k=limpa($("#kpis-reps"));
  var comCt=R.filter(function(r){return r.tel||r.email}).length;
  var rec=R.filter(function(r){return sitRep(r).k!=="antigo"}).length;
  var vr=R.reduce(function(a,b){return a+(b.vr||0)},0);
  k.appendChild(kpi("Representantes", inteiro(R.length), "identificados nos pedidos"));
  k.appendChild(kpi("Com contato recuperado", inteiro(comCt), "telefone ou e-mail no cadastro"));
  var rAt=R.filter(function(x){return x.at}).length;
  k.appendChild(kpi("CNPJ ativo na Receita", inteiro(rAt), inteiro(R.length-rAt)+" baixados ou inaptos", true));
  k.appendChild(kpi("Entregaram no histórico", moedaC(vr), "soma das carteiras"));

  var q=($("#f-rep-q").value||"").toLowerCase(), st=$("#f-rep-sit").value, soCt=$("#f-rep-ct").checked;
  var L=R.filter(function(r){
    if(st && sitRep(r).k!==st) return false;
    if(soCt && !(r.tel||r.email)) return false;
    if(q && (r.nome+" "+r.cidade+" "+r.uf+" "+(r.ufs||[]).join(" ")+" "+r.contato).toLowerCase().indexOf(q)<0) return false;
    return true;
  });
  contador("reps", R.length);
  botaoExport("#reps-dir","representantes",function(){
    var r=[["Código","Nome","CNPJ","Situação na Receita","Contato","Telefone","E-mail",
      "Município","UF","Clientes","Pedidos","Peças","Valor","Último pedido","Estados","Carteira"]];
    L.forEach(function(x){
      r.push([x.cod||"", x.nome||"", cnpjBr(x.cnpj), SITS[x.sit]||x.sit||"", x.contato||"",
        x.tel?telBr(x.tel):"", x.email||"", x.mun||x.cidade||"", x.ufr||x.uf||"",
        csvNum(x.cli||0), csvNum(x.ped||0), csvNum(x.pc||0), csvNum(x.vr||0),
        dataBr(x.ult), (x.ufs||[]).join(" "), sitRep(x).rot]);
    });
    return r;
  });
  $("#reps-dir").textContent = L.length+" de "+R.length;
  L.sort(function(a,b){
    var k=repOrd.k, r=0;
    if(k==="nome")      r=(a.nome||"").localeCompare(b.nome||"","pt");
    else if(k==="uf")   r=((a.ufr||a.uf||"zz")+(a.mun||a.cidade||"")).localeCompare((b.ufr||b.uf||"zz")+(b.mun||b.cidade||""),"pt");
    else if(k==="cli")  r=(a.cli||0)-(b.cli||0);
    else if(k==="ped")  r=(a.ped||0)-(b.ped||0);
    else if(k==="ult")  r=String(a.ult||"").localeCompare(String(b.ult||""));
    else                r=(a.vr||0)-(b.vr||0);
    return r*repOrd.d;
  });
  var c=limpa($("#reps-corpo"));
  if(!L.length){ var v=el("div","vazio"); v.appendChild(el("b",null,"Nenhum representante com esses filtros")); c.appendChild(v); return }
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Representante","Praça","Situação","Contato","Clientes","Pedidos","Valor","Estados"],
    {chaves:{"Representante":"nome","Praça":"uf","Situação":"ult","Clientes":"cli","Pedidos":"ped","Valor":"vr"},
     k:repOrd.k, d:repOrd.d,
     aplica:function(k2,d2){ repOrd={k:k2,d:d2}; pintaReps();
                             anuncia("Representantes ordenados por "+k2); }}));
  var tb=el("tbody");
  L.forEach(function(r){
    var tr=el("tr");
    var pn=el("div","pilha");
    pn.appendChild(lim(titulo(r.nome),"nome"));
    var sub=el("small","mono",cnpjBr(r.cnpj)); sub.title="cód. "+r.cod+" · "+cnpjBr(r.cnpj);
    pn.appendChild(sub);
    tr.appendChild(tdNode(pn));
    tr.appendChild(tdNode(lim(titulo(r.mun||r.cidade)+((r.ufr||r.uf)?" / "+(r.ufr||r.uf):""),"praca")));
    var sr=sitRep(r), psr=el("div","pilha");
    var chsr=tagEl(sr.rot,sr.cls);
    chsr.title = r.ult? ("último pedido em "+dataBr(r.ult)) : "sem pedido registrado no histórico";
    psr.appendChild(chsr);
    var ssr=seloSit(r);
    if(ssr){ ssr.style.fontSize="10.5px"; psr.appendChild(ssr); }
    tr.appendChild(tdNode(psr));
    var pc=el("div","pilha");
    if(r.contato) pc.appendChild(lim(titulo(r.contato),"gente"));
    if(r.tel) pc.appendChild(el("small","mono",telBr(r.tel)));
    if(r.email){ var em=el("small",null,r.email); em.className="lim gente"; em.title=r.email; pc.appendChild(em); }
    if(!r.contato&&!r.tel&&!r.email) pc.appendChild(document.createTextNode("consultar no sisfab"));
    if(r.wa){ var a=el("a","tag i","WA"); a.href="https://wa.me/"+r.wa; a.target="_blank"; a.rel="noopener";
      a.style.cssText="text-decoration:none;margin-left:6px";
      var ul=pc.querySelector("small.mono");
      if(ul){ var cx=el("div"); cx.style.cssText="display:flex;gap:0;align-items:center";
              pc.insertBefore(cx,ul); cx.appendChild(ul); cx.appendChild(a); }
      else pc.appendChild(a); }
    tr.appendChild(tdNode(pc));
    tr.appendChild(tdD(inteiro(r.cli)));
    var cp=el("div","pilha"); cp.style.alignItems="flex-end";
    cp.appendChild(document.createTextNode(inteiro(r.ped)+" ped"));
    cp.appendChild(el("small",null,inteiro(r.pc)+" peças"));
    tr.appendChild(tdNode(cp)).className="d";
    tr.appendChild(tdD(moedaC(r.vr)));
    var U=(r.ufs||[]), ug=el("div","ufs");
    ug.textContent = U.length ? U.slice(0,4).join(" ")+(U.length>4? " +"+(U.length-4) : "") : "—";
    if(U.length) ug.title = U.length+(U.length>1?" estados: ":" estado: ")+U.join(" · ");
    tr.appendChild(tdNode(ug));
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); c.appendChild(env);
}

/* ================= CATÁLOGO ================= */
var ORD_TAM=["PP","P","M","G","GG","XG","XGG","XXG","EG","EGG","U","UNICO"];
function ordTam(a,b){
  var ia=ORD_TAM.indexOf(String(a).toUpperCase()), ib=ORD_TAM.indexOf(String(b).toUpperCase());
  if(ia>=0&&ib>=0) return ia-ib;
  if(ia>=0) return -1;
  if(ib>=0) return 1;
  var na=parseFloat(a), nb=parseFloat(b);
  if(!isNaN(na)&&!isNaN(nb)) return na-nb;
  return String(a).localeCompare(String(b),"pt");
}
function grade(p){
  var cores={}, tot=0, tams={};
  (p.variants?p.variants.nodes:[]).forEach(function(v){
    var q=Number(v.inventoryQuantity)||0; if(q<0) q=0;
    var parte=String(v.title||"").split(" / ");
    var cor = parte.length>1? parte[0] : (parte[0]||"—");
    var tam = parte.length>1? parte[1] : "—";
    if(!cores[cor]) cores[cor]={pecas:0,tams:{}};
    cores[cor].pecas+=q; cores[cor].tams[tam]=(cores[cor].tams[tam]||0)+q; tot+=q;
    tams[tam]=(tams[tam]||0)+q;
  });
  /* a corrida da referencia e a uniao dos tamanhos que existem nela;
     uma cor esta quebrada quando falta peca em algum tamanho da corrida */
  var corrida=Object.keys(tams).sort(ordTam);
  var temTam = corrida.length>1 || (corrida.length===1 && corrida[0]!=="—");
  Object.keys(cores).forEach(function(c){
    cores[c].faltas = temTam ? corrida.filter(function(t){ return !(cores[c].tams[t]>0) }) : [];
    cores[c].quebrada = cores[c].faltas.length>0;
  });
  var pr = (p.variants&&p.variants.nodes[0]) ? Number(p.variants.nodes[0].price)||0 : 0;
  var sku = (p.variants&&p.variants.nodes[0]) ? ref(p.variants.nodes[0].sku) : "";
  return {cores:cores, total:tot, preco:pr, sku:sku, tams:tams, corrida:corrida, temTam:temTam};
}
/* matriz cor x tamanho, mostrada na gaveta */
function corpoCatalogo(x,piso){
  var box=el("div"); box.style.cssText="display:grid;gap:16px";
  var g=x.g;
  var r1=el("div"); r1.appendChild(el("div","r","Grade por cor e tamanho")).style.cssText="margin-bottom:6px";
  var env=el("div","tab-env"); env.style.maxHeight="none";
  var t=el("table");
  var th=el("thead"), tr0=el("tr");
  tr0.appendChild(el("th",null,"Cor"));
  (g.temTam?g.corrida:["Peças"]).forEach(function(tm){ var h=el("th","d",tm); tr0.appendChild(h) });
  tr0.appendChild(el("th","d","Total"));
  tr0.appendChild(el("th",null,"Situação"));
  th.appendChild(tr0); t.appendChild(th);
  var tb=el("tbody");
  Object.keys(g.cores).sort().forEach(function(cor){
    var c=g.cores[cor], tr=el("tr");
    tr.appendChild(tdNode(el("span","lim nome",cor)));
    if(g.temTam){
      g.corrida.forEach(function(tm){
        var q=c.tams[tm]||0;
        var td=tdD(q? inteiro(q) : "—");
        if(!q) td.style.color="var(--cr)";
        tr.appendChild(td);
      });
    } else tr.appendChild(tdD(inteiro(c.pecas)));
    tr.appendChild(tdD(inteiro(c.pecas)));
    var est = c.quebrada ? tagEl("Falta "+c.faltas.join(", "),"r")
            : (c.pecas<piso ? tagEl("Abaixo do piso","a") : tagEl("Completa","v"));
    tr.appendChild(tdNode(est));
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); r1.appendChild(env); box.appendChild(r1);
  var n=el("p","nota","Corrida da referência: "+(g.temTam? g.corrida.join(" · ") : "sem tamanho na variante")+
    ". Uma cor está quebrada quando falta peça em algum tamanho da corrida — ela não fecha grade e não deveria ser ofertada ao lojista.");
  n.style.margin="0"; box.appendChild(n);
  return box;
}
function pintaCatalogo(){
  var c=limpa($("#cat-corpo"));
  if(!LIVE.catalogo){ c.appendChild(el("div","carregando","Consultando a Shopify…")); return }
  var corte=Number($("#p-corte").value)||0, piso=Number($("#p-piso").value)||0, fator=Number($("#p-fator").value)||0.55;
  var P=(LIVE.catalogo.products?LIVE.catalogo.products.nodes:[]).map(function(p){
    var g=grade(p);
    var coresOk=Object.keys(g.cores).filter(function(k){ return g.cores[k].pecas>=piso });
    var pecasOk=coresOk.reduce(function(a,k){ return a+g.cores[k].pecas },0);
    return {p:p, g:g, coresOk:coresOk, pecasOk:pecasOk, passa: g.total>=corte && coresOk.length>0};
  });
  contador("cat", P.length);
  var dentro=P.filter(function(x){return x.passa});
  var pecasDentro=dentro.reduce(function(a,x){return a+x.pecasOk},0);
  var valor=dentro.reduce(function(a,x){return a+x.pecasOk*x.g.preco*fator},0);

  var k=limpa($("#kpis-cat"));
  var tb=statTabela();
  k.appendChild(kpi("Referências publicadas", inteiro(P.length), LIVE.catalogo.title||"coleção de atacado"));
  k.appendChild(kpi("Peças no estoque", inteiro(P.reduce(function(a,x){return a+x.g.total},0)), "somando todas as grades"));
  k.appendChild(kpi("Preço de lojista hoje", tb? (tb.semDesconto? "= varejo" : pct(tb.valor)+" off") : "—",
    tb? (tb.semDesconto? "tabela com 0% e sem preço fixo" : tb.nome) : "tabela não lida", tb&&tb.semDesconto));
  k.appendChild(kpi("Peças por SKU", (function(){
    var sk=P.reduce(function(a,x){return a+(x.p.variants?x.p.variants.nodes.length:0)},0);
    var pc=P.reduce(function(a,x){return a+x.g.total},0);
    return sk? (pc/sk).toLocaleString("pt-BR",{maximumFractionDigits:2}) : "—";
  })(), "grade rasa exige mínimo por cor"));
  var qb=P.reduce(function(a,x){ return a+Object.keys(x.g.cores).filter(function(c){return x.g.cores[c].quebrada}).length },0);
  var qbRef=P.filter(function(x){ return Object.keys(x.g.cores).some(function(c){return x.g.cores[c].quebrada}) }).length;
  k.appendChild(kpi("Cores com grade quebrada", inteiro(qb), qb? ("em "+qbRef+" referências · falta tamanho") : "todas as cores fecham grade", qb>0));

  var s=limpa($("#cat-sim"));
  var kg=el("div","grade");
  kg.appendChild(kpi("Referências dentro do corte", inteiro(dentro.length), "de "+P.length+" publicadas", true));
  kg.appendChild(kpi("Peças ofertáveis", inteiro(pecasDentro), "só cores acima do piso"));
  kg.appendChild(kpi("Valor da oferta", moedaC(valor), "ao fator "+fator));
  kg.appendChild(kpi("Ficam de fora", inteiro(P.length-dentro.length), "grade curta demais"));
  s.appendChild(kg);
  s.appendChild(el("p","nota","Corte é o mínimo de peças da referência inteira; piso é o mínimo por cor, para não vender uma cor com duas peças. O fator multiplica o preço de varejo para chegar ao preço de lojista — é o número que ainda precisa entrar na tabela da Shopify."));

  var q=($("#f-cat-q").value||"").toLowerCase(), ord=$("#f-cat-ord").value, soFora=$("#f-cat-fora").checked;
  var L=P.filter(function(x){
    if(soFora && x.passa) return false;
    if(q && (x.p.title+" "+x.g.sku).toLowerCase().indexOf(q)<0) return false;
    return true;
  });
  var kc=ord||"pc", dc=dirDe(kc==="tit"?"nome":(kc==="pr"?"vr":"pc"), catDir);
  L.sort(function(a,b){
    var r=0;
    if(kc==="tit")     r=(a.p.title||"").localeCompare(b.p.title||"","pt");
    else if(kc==="pr") r=a.g.preco-b.g.preco;
    else               r=a.g.total-b.g.total;
    return r*dc;
  });
  $("#cat-dir").textContent = L.length+" de "+P.length;
  botaoExport("#cat-dir","catalogo-atacado",function(){
    var r=[["Referência","SKU","Cores","Peças","Preço de varejo","Preço de lojista ao fator "+fator,
      "Corrida","Cores com grade quebrada","Tamanhos em falta","Dentro do corte"]];
    L.forEach(function(x){
      var qs=Object.keys(x.g.cores).filter(function(c){return x.g.cores[c].quebrada});
      var faltas=qs.map(function(c){ return c+" ("+x.g.cores[c].faltas.join(" ")+")" }).join(" | ");
      r.push([x.p.title||"", x.g.sku||"", csvNum(Object.keys(x.g.cores).length), csvNum(x.g.total),
        csvNum(x.g.preco), csvNum(Math.round(x.g.preco*fator*100)/100),
        x.g.temTam? x.g.corrida.join(" ") : "", csvNum(qs.length), faltas, x.passa?"sim":"não"]);
    });
    return r;
  });
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Referência","Cores","Estoque","Preço varejo","Preço lojista","Grade","Corte"],
    {chaves:{"Referência":"tit","Estoque":"pc","Preço varejo":"pr"},
     k:kc, d:dc,
     aplica:function(k2,d2){ $("#f-cat-ord").value=k2; catDir=d2; pintaCatalogo();
                             anuncia("Catálogo ordenado por "+k2); }}));
  var tbb=el("tbody");
  L.forEach(function(x){
    var tr=el("tr");
    var pn=el("div","pilha");
    var nmc=el("button","lim nome",x.p.title||"—"); nmc.type="button"; nmc.title=x.p.title||"";
    nmc.style.cssText="background:none;border:0;padding:0;font:inherit;font-weight:600;color:var(--ac);text-align:left;cursor:pointer";
    nmc.onclick=function(){
      Array.prototype.forEach.call(document.querySelectorAll("tr.sel"),function(r){ r.classList.remove("sel") });
      tr.classList.add("sel");
      var chips=[x.g.sku||"sem SKU", inteiro(x.g.total)+" peças", Object.keys(x.g.cores).length+" cores"];
      chips.push(tagEl(x.passa?"Dentro do corte":"Fora do corte", x.passa?"v":"r"));
      window.abreGaveta(x.p.title||"—", chips, corpoCatalogo(x,piso));
    };
    pn.appendChild(nmc);
    var sub=x.g.temTam ? (x.g.sku? x.g.sku+" · " : "")+x.g.corrida.join(" ") : (x.g.sku||"");
    if(sub) pn.appendChild(el("small","mono",sub));
    tr.appendChild(tdNode(pn));
    tr.appendChild(tdD(Object.keys(x.g.cores).length));
    tr.appendChild(tdD(inteiro(x.g.total)));
    tr.appendChild(tdD(moeda(x.g.preco)));
    tr.appendChild(tdD(moeda(x.g.preco*fator)));
    var gg=el("div"); gg.style.cssText="display:flex;gap:4px;flex-wrap:wrap;max-width:300px";
    Object.keys(x.g.cores).sort().forEach(function(cor){
      var c=x.g.cores[cor], n=c.pecas;
      var cls = c.quebrada ? "r" : (n>=piso ? "v" : "a");
      var ch=tagEl(cor+" "+n, cls);
      ch.title = c.quebrada ? "Grade quebrada: falta "+c.faltas.join(", ")
               : (n<piso ? "Abaixo do piso de "+piso+" peças" : "Grade completa");
      gg.appendChild(ch);
    });
    tr.appendChild(tdNode(gg));
    var tdc=tdNode(tagEl(x.passa?"dentro":"fora", x.passa?"v":"r")); tdc.className="acao"; tr.appendChild(tdc);
    tbb.appendChild(tr);
  });
  t.appendChild(tbb); env.appendChild(t); limpa($("#cat-corpo")).appendChild(env);
}

/* ================= POLÍTICA ================= */
var reguaRasc=null;
function pintaRegua(){
  if(!reguaRasc) reguaRasc = JSON.parse(JSON.stringify(reguaAtual()));
  var t=limpa($("#t-regua"));
  t.appendChild(cabecalho(["A partir de","Desconto do varejo","Preço de uma peça de R$ 100","Folga até o atacado","Remover"]));
  var tb=el("tbody");
  var fator=Number($("#p-fator")?$("#p-fator").value:0.55)||0.55;
  var atac=100*fator;
  reguaRasc.faixas.forEach(function(f,i){
    var tr=el("tr");
    var tdi;var i1=el("input"); i1.type="number"; i1.min="2"; i1.max="500"; i1.value=f.min; i1.style.width="78px";
    i1.setAttribute("aria-label","Quantidade mínima da faixa "+(i+1));
    i1.oninput=function(){ f.min=Number(i1.value)||0; pintaRegua() };
    tdi=tdNode(i1); tdi.className="d"; tr.appendChild(tdi);
    var i2=el("input"); i2.type="number"; i2.min="0"; i2.max="60"; i2.step="0.5"; i2.value=f.pct; i2.style.width="78px";
    i2.setAttribute("aria-label","Desconto da faixa "+(i+1));
    i2.oninput=function(){ f.pct=Number(i2.value)||0; pintaRegua() };
    var w=el("div"); w.style.cssText="display:flex;gap:6px;align-items:center;justify-content:flex-end";
    w.appendChild(i2); w.appendChild(el("span",null,"%"));
    var tdw=tdNode(w); tdw.className="d"; tr.appendChild(tdw);
    var pv=100*(1-f.pct/100);
    tr.appendChild(tdD(moeda(pv)));
    var folga=pv-atac;
    var cel=el("td","d");
    cel.appendChild(tagEl(moeda(folga), folga<=0?"r":(folga<atac*0.2?"a":"v")));
    tr.appendChild(cel);
    var bx=el("button","bt mini mau","Remover"); bx.type="button"; bx.setAttribute("aria-label","Remover a faixa a partir de "+f.min+" peças");
    bx.onclick=function(){ reguaRasc.faixas.splice(i,1); pintaRegua() };
    var tdx=tdNode(bx); tdx.className="acao"; tr.appendChild(tdx);
    tb.appendChild(tr);
  });
  var trA=el("tr"); var tdA=el("td"); tdA.colSpan=5;
  tdA.style.cssText="background:var(--navy-claro);font-weight:600";
  tdA.textContent="Preço de lojista no atacado, ao fator "+fator+": "+moeda(atac)+" na peça de R$ 100";
  trA.appendChild(tdA); tb.appendChild(trA);
  t.appendChild(tb);
  reguaEstado();
}
function pintaCond(){
  var t=limpa($("#t-cond"));
  t.appendChild(cabecalho(["Condição","Clientes que usaram"]));
  var tb=el("tbody");
  [["30/60/90/120",89],["40/70/100",84],["40/70/100/130",78],["60 dias",50],["À vista",43],["90 dias",36],
   ["30/60/90",28],["60/90/120/150",27],["40/70/100/130/160",23],["30/60/90/120/150",22],["40/70",22],["60/90/120",21]]
  .forEach(function(r){
    var tr=el("tr"); tr.appendChild(td(r[0])); tr.appendChild(tdD(inteiro(r[1]))); tb.appendChild(tr);
  });
  t.appendChild(tb);
}
function pintaRegras(){
  var p=limpa($("#regras"));
  [["O site não pode parar","A loja está no ar vendendo. Varejo e atacado convivem na mesma Shopify como dois ambientes; nada da reestruturação tira o site do ar."],
   ["Consumidor não vê atacado","Quem entra sem login não vê peça nem preço de atacado. Só lojista aprovado e logado entra na área, e lá não há peça de varejo."],
   ["Promoção de varejo não vale no atacado","Leve 6 Pague 5, frete grátis por valor, 5% no PIX, parcelamento e troca em 30 dias não aparecem nem são concedidos ao lojista."],
   ["A referência é a mesma","E-commerce, loja própria e atacado usam a mesma referência, cor e tamanho. Não existe SKU separado de atacado; o que muda é a etiqueta impressa, que na peça de atacado traz a palavra atacado."],
   ["Atacado fora do Google","Nenhum produto, variante ou preço de atacado vai para o canal Google & YouTube da Shopify nem para o Merchant Center."],
   ["Decisão comercial é humana","Crédito, limite, preço e sugestão de IA passam por validação sua. Automação de WhatsApp não pode ser invasiva."]]
  .forEach(function(r){
    var a=el("div","aviso"); a.appendChild(el("div","ico","·"));
    var c=el("div"); c.style.minWidth="0"; c.appendChild(el("b",null,r[0])); c.appendChild(el("p",null,r[1]));
    a.appendChild(c); p.appendChild(a);
  });
}

/* ================= CONFORMIDADE ================= */
var VALIDADE_DIAS=30;   /* conferência manual vence em 30 dias */
function diasDesde(iso){
  if(!iso) return null;
  var d=new Date(iso+"T00:00:00"), h=new Date(hojeIso2()+"T00:00:00");
  return Math.round((h-d)/86400000);
}
function camadas(){
  var tb=statTabela();
  var cat=LIVE.catalogo;
  var prods=(cat&&cat.products)? cat.products.nodes : [];
  var skus=prods.map(function(p){
    return (p.variants&&p.variants.nodes[0])? String(p.variants.nodes[0].sku||"") : "";
  }).filter(function(x){return x});
  var comAtc=skus.filter(function(k){ return /^ATC-/i.test(k) }).length;
  var quebradas=0, coresTot=0;
  prods.forEach(function(p){
    var g=grade(p), ks=Object.keys(g.cores);
    coresTot+=ks.length;
    quebradas+=ks.filter(function(c){return g.cores[c].quebrada}).length;
  });

  return [
  {id:"tabela", tit:"Lista de preços de lojista", grupo:"Preço",
   porque:"Sem fator na lista ATACADO 2026 o lojista aprovado entra na área e vê o preço de varejo.",
   auto:function(){
     if(!tb) return {st:"nao", ev:"tabela não lida nesta sessão"};
     if(tb.semDesconto) return {st:"falha", ev:'"'+tb.nome+'" com 0% e '+tb.fixos+" preços fixos"+(tb.medidoEm?" (medida em "+tb.medidoEm+")":"")};
     return {st:"ok", ev:'"'+tb.nome+'" aplicando '+(tb.tipo==="PERCENTAGE_DECREASE"? pct(tb.valor)+" de desconto" : tb.tipo)};
   }},
  {id:"catalogo", tit:"Catálogo de atacado publicado", grupo:"Produto",
   porque:"É a coleção que o lojista logado enxerga. Vazia, não há o que vender.",
   auto:function(){
     if(!cat) return {st:"nao", ev:"coleção não lida nesta sessão"};
     var n=cat.productsCount? cat.productsCount.count : prods.length;
     if(n<2) return {st:"falha", ev:n+" referência na coleção"};
     return {st:"ok", ev:inteiro(n)+" referências em \u201c"+(cat.title||"coleção de atacado")+"\u201d"};
   }},
  {id:"sku", tit:"SKU próprio ATC-", grupo:"Produto",
   porque:"O SKU separado é o que permite ao Bling tratar a peça de atacado como item distinto do e-commerce.",
   auto:function(){
     if(!prods.length) return {st:"nao", ev:"catálogo não lido nesta sessão"};
     if(comAtc===0) return {st:"falha", ev:"nenhum dos "+skus.length+" SKUs começa com ATC-"};
     if(comAtc<skus.length) return {st:"alerta", ev:comAtc+" de "+skus.length+" SKUs com o prefixo ATC-"};
     return {st:"ok", ev:"todos os "+skus.length+" SKUs com o prefixo ATC-"};
   }},
  {id:"grade", tit:"Grade fechada ofertável", grupo:"Produto",
   porque:"O lojista compra grade. Cor sem peça no meio da corrida não fecha grade e não deveria ser ofertada.",
   auto:function(){
     if(!prods.length) return {st:"nao", ev:"catálogo não lido nesta sessão"};
     if(!quebradas) return {st:"ok", ev:"as "+coresTot+" cores fecham grade"};
     return {st:"alerta", ev:quebradas+" de "+coresTot+" cores com tamanho faltando"};
   }},
  {id:"regua", tit:"Régua de desconto do varejo", grupo:"Preço",
   porque:"Sem ela a camada do meio não existe e o desconto por quantidade pode encostar no preço de lojista.",
   auto:function(){
     if(!REGUA) return {st:"falha", ev:"nenhuma régua salva"};
     return {st:"ok", ev:REGUA.faixas.length+" faixas salvas"};
   }},
  {id:"empresas", tit:"Empresas B2B na Shopify", grupo:"Cadastro",
   porque:"É onde o lojista aprovado passa a existir. Serve de contraprova da aprovação.",
   auto:function(){
     if(!LIVE.empresas) return {st:"nao", ev:"não lido nesta sessão"};
     if(!LIVE.empresas.length) return {st:"alerta", ev:"nenhuma empresa criada ainda"};
     return {st:"ok", ev:LIVE.empresas.length+" empresa(s) em b2b.companies"};
   }},
  {id:"deposito", tit:"Depósito ATACADO separado no Bling", grupo:"Estoque",
   porque:"É a única camada que impede o marketplace de vender a reserva do atacado. Risco número um do projeto.",
   manual:"No Bling da filial, confirmar que existe o depósito ATACADO e que ele não está mapeado para os canais B2C nem para o Mercado Livre."},
  {id:"vazamento", tit:"Produtos ATC- fora do B2C e do marketplace", grupo:"Estoque",
   porque:"Um ATC- publicado no canal de varejo ou no Mercado Livre vende a peça reservada ao lojista.",
   manual:"Conferir no Bling e na Shopify que nenhum produto ATC- está publicado no canal B2C nem enviado ao Mercado Livre."},
  {id:"serie", tit:"Série de NF-e do atacado", grupo:"Fiscal",
   porque:"Série separada é o que permite conferir e medir o atacado, inclusive para o Compete-ES.",
   manual:"No Bling, confirmar que o atacado emite em série própria, diferente da do e-commerce."},
  {id:"icms", tit:"Alíquota de ICMS uniforme nas referências", grupo:"Fiscal",
   porque:"Em 16/09 quatro referências estavam com 17% fora da UF contra 12% nas outras 34. Faturar assim gera nota errada.",
   manual:"No sisfab, conferir AliqICMS_PJ_ForaUF nas refs 22800317, 22800320, 22800322 e 26800320."},
  {id:"transferencia", tit:"Transferência matriz → filial em dia", grupo:"Estoque",
   porque:"A peça nasce na matriz e precisa chegar ao depósito ATACADO da filial. Sem gatilho, o catálogo promete o que não há.",
   manual:"Conferir se o saldo do depósito ATACADO cobre o que o catálogo publica, e quando saiu a última NF de transferência."},
  {id:"frete", tit:"Frete próprio do atacado", grupo:"Entrega",
   porque:"O perfil do varejo dá frete grátis acima de R$ 300. Num pedido de atacado isso é prejuízo direto.",
   manual:"Na Shopify, confirmar que o mercado de lojistas usa um perfil de entrega próprio, sem o frete grátis do varejo."},
  {id:"preco_oculto", tit:"Preço escondido de quem não está logado", grupo:"Cadastro",
   porque:"Proteção de praça: o consumidor final não pode ver preço de atacado.",
   manual:"Abrir o catálogo de atacado numa janela anônima e confirmar que preço e peças não aparecem sem login."}
  ];
}
var CONF_ST={ok:{rot:"Em ordem",cls:"v"}, falha:{rot:"Fora do lugar",cls:"r"},
  alerta:{rot:"Atenção",cls:"a"}, nao:{rot:"Não lido",cls:""},
  conferido:{rot:"Conferido",cls:"v"}, vencido:{rot:"A reconferir",cls:"a"}, pendente:{rot:"Nunca conferido",cls:"a"}};
function pintaConformidade(){
  var box=$("#conf-corpo"); if(!box) return;
  var C=camadas(), linhas=[], cont={ok:0,falha:0,alerta:0,nao:0,pend:0};
  C.forEach(function(c){
    var r;
    if(c.auto){
      r=c.auto(); r.tipo="auto";
      if(r.st==="ok") cont.ok++; else if(r.st==="falha") cont.falha++;
      else if(r.st==="alerta") cont.alerta++; else cont.nao++;
    } else {
      var g=CONF[c.id]||{}, d=diasDesde(g.em);
      if(!g.em){ r={st:"pendente", ev:"nunca conferido", tipo:"manual"}; cont.pend++; }
      else if(d>VALIDADE_DIAS){ r={st:"vencido", ev:"conferido em "+dataBr(g.em)+" · há "+d+" dias", tipo:"manual"}; cont.pend++; }
      else { r={st:"conferido", ev:"conferido em "+dataBr(g.em)+(g.obs? " · "+g.obs : ""), tipo:"manual"}; cont.ok++; }
    }
    linhas.push({c:c, r:r});
  });

  var k=limpa($("#kpis-conf"));
  k.appendChild(kpi("Camadas em ordem", inteiro(cont.ok), "de "+C.length+" conferidas"));
  k.appendChild(kpi("Fora do lugar", inteiro(cont.falha), cont.falha? "precisa de ação agora":"nenhuma falha automática", cont.falha>0));
  k.appendChild(kpi("Atenção", inteiro(cont.alerta), "parcialmente no lugar"));
  k.appendChild(kpi("Esperando conferência", inteiro(cont.pend), "manuais nunca feitas ou vencidas"));
  $("#conf-dir").textContent = C.length+" camadas · automáticas releem a cada atualização";
  contador("conf", (cont.falha+cont.pend) || null);

  limpa(box);
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Camada","Área","Situação","Evidência","Por que importa","Conferência"]));
  var tb=el("tbody");
  linhas.forEach(function(L){
    var tr=el("tr"), c=L.c, r=L.r, est=CONF_ST[r.st]||CONF_ST.nao;
    var nm2=el("div",null,c.tit);
    nm2.style.cssText="font-weight:600;color:var(--tinta);white-space:normal;max-width:230px;line-height:1.35";
    tr.appendChild(tdNode(nm2));
    tr.appendChild(tdNode(tagEl(c.grupo,"")));
    tr.appendChild(tdNode(tagEl(est.rot, est.cls)));
    var ev=el("div"); ev.style.cssText="max-width:300px;white-space:normal;line-height:1.45";
    ev.textContent=r.ev||"—"; tr.appendChild(tdNode(ev));
    var pq=el("div"); pq.style.cssText="max-width:380px;white-space:normal;line-height:1.45;color:var(--tinta-3)";
    pq.textContent=c.porque; tr.appendChild(tdNode(pq));
    var td6=el("td","acao");
    if(r.tipo==="manual"){
      var cx=el("div"); cx.style.cssText="display:flex;gap:6px;align-items:center;justify-content:flex-end";
      var di=el("input"); di.type="date"; di.value=(CONF[c.id]||{}).em||"";
      di.setAttribute("aria-label","Data da conferência de "+c.tit);
      di.title=c.manual;
      di.onchange=function(){ salvaConf(c.id,{em:di.value}) };
      var bh=el("button","bt mini","Hoje"); bh.type="button";
      bh.onclick=function(){ salvaConf(c.id,{em:hojeIso2()}) };
      cx.appendChild(di); cx.appendChild(bh);
      td6.appendChild(cx);
    } else {
      var au=el("span","mono","automática"); au.title="Relida a cada Atualizar, a partir do que a página já lê";
      td6.appendChild(au);
    }
    tr.appendChild(td6);
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); box.appendChild(env);

  var lim2=limpa($("#conf-limites"));
  var dl=el("dl");
  [["Bling","Esta página não fala com o Bling. Depósito, série de NF-e e títulos em aberto ficam como conferência manual até existir um caminho de leitura."],
   ["Publicação por canal","A consulta atual traz a coleção e o estoque, mas não em quais canais cada produto está publicado. Por isso o vazamento para o B2C e para o marketplace é manual."],
   ["sisfab","O saldo da matriz e as alíquotas por referência vêm do sisfab, que a página ainda não lê nesta tela."],
   ["Regra de quantidade","Grade fechada e múltiplo de venda são configuração do catálogo B2B da Shopify e não aparecem na consulta atual."]]
   .forEach(function(p){
    var r=el("div","par"); r.appendChild(el("dt",null,p[0])); r.appendChild(el("dd",null,p[1])); dl.appendChild(r);
  });
  lim2.appendChild(dl);
  var n=el("p","nota","Cada conferência manual vence em "+VALIDADE_DIAS+" dias: depois disso ela volta para \u201ca reconferir\u201d, para não virar um carimbo antigo que ninguém revisita.");
  lim2.appendChild(n);
}

/* ================= ENDEREÇOS (estoque do e-commerce no Centro Criativo) =================
   A base vem do bloco knk-enderecos: endereço fixo por SKU + quantidade da montagem.
   Ajuste feito aqui (peça nova, troca de lugar) fica em localStorage até ser incorporado
   à base; por isso ele aparece marcado e tem exportação própria. */
var ENDB=null, ENDS=[], ENDP={}, ENDCOR={}, ENDSKU={}, endEst="E1", endPag=0, END_POR=100, endOrd={k:"idx",d:1};
var AJ_CH="knk-end-ajustes", AJ={};
var END_RX=/^E([1-9])-C(\d{2})-N(\d)$/;

function endNorm(s){ return String(s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"") }
function endValido(e){
  var t=String(e||"").trim().toUpperCase(), m=END_RX.exec(t);
  if(!m||!ENDB) return null;
  var est=ENDB.estantes[Number(m[1])-1], c=Number(m[2]), n=Number(m[3]);
  if(!est||c<1||c>est[1]||n<1||n>ENDB.niveis) return null;
  return t;
}
function endIdx(e){
  var m=END_RX.exec(e); if(!m||!ENDB) return 1e9;
  var b=0; for(var i=0;i<Number(m[1])-1;i++) b+=ENDB.estantes[i][1]*ENDB.niveis;
  return b+(Number(m[2])-1)*ENDB.niveis+Number(m[3])-1;
}
function todosEnd(est){
  var L=[];
  ENDB.estantes.forEach(function(es){
    if(est && es[0]!==est) return;
    for(var c=1;c<=es[1];c++) for(var n=1;n<=ENDB.niveis;n++) L.push(es[0]+"-C"+String(c).padStart(2,"0")+"-N"+n);
  });
  return L;
}
function nomeCat(i){ return ENDB && ENDB.cats[i]!=null ? ENDB.cats[i] : "—" }
function carregaEnd(){
  AJ={};
  try{ var g=localStorage.getItem("knk-end-est"); if(g) endEst=g }catch(e){}
  montaEnd();
}
function gravaAj(){ return false }
function montaEnd(){
  ENDS=[]; ENDP={}; ENDCOR={}; ENDSKU={};
  if(!ENDB) return;
  ENDB.skus.forEach(function(r){
    var rf=r[0].slice(0,8), info=ENDB.refs[rf]||["—",0];
    var o={sku:r[0], ref:rf, cod:r[0].slice(8,12), cor:r[1], tam:r[2], ecom:r[3], nf:r[4], res:r[5],
      pos:r[6].map(function(p){ return [p[0],p[1]] }), nome:info[0], cat:info[1], aj:null, novo:false};
    ENDS.push(o); ENDSKU[o.sku]=o;
  });
  Object.keys(AJ).forEach(function(s){
    var a=AJ[s]; if(!a || !endValido(a.end)) return;
    var o=ENDSKU[s];
    if(o){
      var q=o.pos.reduce(function(t,p){ return t+p[1] },0);
      o.pos=[[a.end,q]]; o.aj=a;
    } else {
      o={sku:s, ref:s.slice(0,8), cod:s.slice(8,12), cor:a.cor||"—", tam:a.tam||"—", ecom:0, nf:0, res:0,
         pos:[[a.end, Number(a.qtd)||0]], nome:a.nome||"Peça nova", cat:Number(a.cat)||0, aj:a, novo:true};
      ENDS.push(o); ENDSKU[s]=o;
    }
  });
  ENDS.forEach(function(o){
    o.prat=o.pos.reduce(function(t,p){ return t+p[1] },0);
    o.eco=!o.novo && !o.nf && o.ecom>0;
    o.end=o.pos.map(function(p){ return p[0] }).join(" + ");
    o.idx=o.pos.length? endIdx(o.pos[0][0]) : 1e9;
    o.busca=endNorm([o.sku,o.ref,o.nome,o.cor,o.tam,o.end,nomeCat(o.cat)].join(" "));
    o.pos.forEach(function(p){ (ENDP[p[0]]=ENDP[p[0]]||[]).push({o:o,q:p[1]}) });
    (ENDCOR[o.ref+"|"+o.cod]=ENDCOR[o.ref+"|"+o.cod]||[]).push(o);
  });
}
function ocup(e){ return (ENDP[e]||[]).reduce(function(t,x){ return t+x.q/(ENDB.cap[x.o.cat]||25) },0) }
function pecasEm(e){ return (ENDP[e]||[]).reduce(function(t,x){ return t+x.q },0) }
function catDom(e){
  var c={}, m=null;
  (ENDP[e]||[]).forEach(function(x){ c[x.o.cat]=(c[x.o.cat]||0)+x.q/(ENDB.cap[x.o.cat]||25) });
  Object.keys(c).forEach(function(k){ if(m==null||c[k]>c[m]) m=k });
  return m==null? null : Number(m);
}
function coresEm(e){ var s={}; (ENDP[e]||[]).forEach(function(x){ s[x.o.ref+"|"+x.o.cod]=1 }); return Object.keys(s).length }
function endBusca(){ return endNorm(($("#f-end-q")||{}).value||"").split(/\s+/).filter(Boolean) }
function endFiltrada(){
  var ws=endBusca(), est=$("#f-end-est").value, cat=$("#f-end-cat").value,
      soR=$("#f-end-res").checked, soA=$("#f-end-aj").checked, og=$("#f-end-og").value;
  return ENDS.filter(function(o){
    if(est && !o.pos.some(function(p){ return p[0].slice(0,2)===est })) return false;
    if(cat!=="" && String(o.cat)!==cat) return false;
    if(soR && !o.res) return false;
    if(soA && !o.aj) return false;
    if(og==="e" && !o.eco) return false;
    if(og==="n" && o.eco) return false;
    for(var i=0;i<ws.length;i++) if(o.busca.indexOf(ws[i])<0) return false;
    return true;
  });
}
function endFiltroAtivo(){
  return endBusca().length>0 || $("#f-end-cat").value!=="" || $("#f-end-res").checked || $("#f-end-aj").checked || $("#f-end-og").value!=="";
}

function pintaEnderecos(){
  var sec=$("#s-end"); if(!sec) return;
  contador("end", ENDB? ENDS.length : null);
  var av=limpa($("#end-avisos"));
  if(!ENDB){
    av.appendChild(avisoEl("cri","!","Base de endereços não carregou","O bloco knk-enderecos desta página está ausente ou corrompido."));
    return;
  }
  var nAj=Object.keys(AJ).length;
  if(nAj) av.appendChild(avisoEl("ate","!", nAj+(nAj===1?" ajuste está":" ajustes estão")+" só neste computador",
    "Peça nova ou troca de lugar salva aqui ainda não faz parte da base. Exporte os ajustes e mande para incorporar; outro computador não os vê."));
  var todos=todosEnd(), ocupadas=todos.filter(function(e){ return ENDP[e] && ENDP[e].length });
  var prat=ENDS.reduce(function(t,o){ return t+o.prat },0), res=ENDS.reduce(function(t,o){ return t+o.res },0);
  var cheias=ocupadas.filter(function(e){ return ocup(e)>=0.95 }).length;
  var refs={}; ENDS.forEach(function(o){ refs[o.ref]=1 });
  var k=limpa($("#kpis-end"));
  k.appendChild(kpi("Prateleiras ocupadas", inteiro(ocupadas.length)+" / "+inteiro(todos.length), (todos.length-ocupadas.length)+" livres · "+cheias+" cheias", true));
  var pNF=ENDS.reduce(function(t,o){ return t+(o.eco?0:o.prat) },0), pEC=prat-pNF;
  k.appendChild(kpi("NF na prateleira", inteiro(pNF), "guardar e contar agora"));
  k.appendChild(kpi("NF na reserva", inteiro(res), "caixas com o endereço-casa", res>0));
  k.appendChild(kpi("Estoque ativo", inteiro(pEC), "espaço reservado · vem da fábrica"));
  k.appendChild(kpi("SKUs endereçados", inteiro(ENDS.length), Object.keys(refs).length+" referências"));
  k.appendChild(kpi("Ajustes locais", inteiro(nAj), nAj? "exportar e incorporar" : "base igual à montagem", nAj>0));
  pintaMapa(); pintaBibEnd(); pintaAjustes(); pintaRegrasEnd();
}

function pintaMapa(){
  var abas=limpa($("#est-abas"));
  if(!ENDB.estantes.some(function(x){ return x[0]===endEst })) endEst=ENDB.estantes[0][0];
  ENDB.estantes.forEach(function(es){
    var oc=todosEnd(es[0]).filter(function(e){ return ENDP[e] }).length;
    var b=el("button","bt mini","Estante "+es[0].slice(1)+" · "+oc+"/"+(es[1]*ENDB.niveis)); b.type="button";
    b.setAttribute("aria-pressed", es[0]===endEst?"true":"false");
    b.onclick=function(){ endEst=es[0]; try{ localStorage.setItem("knk-end-est",endEst) }catch(e){} pintaMapa() };
    abas.appendChild(b);
  });
  var es=ENDB.estantes.filter(function(x){ return x[0]===endEst })[0];
  var marca={}, filtro=endFiltroAtivo();
  if(filtro) endFiltrada().forEach(function(o){ o.pos.forEach(function(p){ marca[p[0]]=1 }) });
  var m=limpa($("#mapa")); m.style.gridTemplateColumns="30px repeat("+es[1]+",70px)";
  m.appendChild(el("div","rot",""));
  for(var c=1;c<=es[1];c++) m.appendChild(el("div","rot","C"+String(c).padStart(2,"0")));
  var tot=0, oc=0;
  for(var n=ENDB.niveis;n>=1;n--){
    m.appendChild(el("div","rot","N"+n));
    for(c=1;c<=es[1];c++){
      (function(e){
        var b=el("button","cel"); b.type="button";
        var p=pecasEm(e), o=ocup(e), cd=catDom(e);
        tot++;
        if(!p){ b.classList.add("livre"); b.appendChild(el("b",null,"livre")); b.appendChild(el("small",null,e.slice(3))); }
        else {
          oc++;
          var pe=(ENDP[e]||[]).reduce(function(t,x){ return t+(x.o.eco?x.q:0) },0), pn2=p-pe;
          b.appendChild(el("b",null,inteiro(p)+" pç"));
          if(pe && !pn2){ b.classList.add("soeco"); b.appendChild(el("small",null,"ativo · vem depois")) }
          else {
            b.style.background="var(--z"+cd+")";
            if(pe){ b.classList.add("mista"); b.appendChild(el("small",null,"NF "+pn2+" + "+pe)) }
            else b.appendChild(el("small",null,coresEm(e)+(coresEm(e)===1?" cor":" cores")));
          }
          var bar=el("i","oc"+(o>1.001?" cheia":"")); bar.style.width=Math.min(100,Math.round(o*100))+"%"; b.appendChild(bar);
        }
        if(filtro){ if(marca[e]) b.classList.add("marca"); else b.classList.add("apaga"); }
        b.title=e+(p? " · "+nomeCat(cd)+" · "+p+" peças · "+Math.round(o*100)+"% ocupada"+(b.classList.contains("soeco")? " · só estoque ativo (vem depois)" : b.classList.contains("mista")? " · divide com o estoque ativo" : "") : " · livre");
        b.setAttribute("aria-label", b.title);
        b.onclick=function(){ gavetaPos(e) };
        m.appendChild(b);
      })(es[0]+"-C"+String(c).padStart(2,"0")+"-N"+n);
    }
  }
  var nm=Object.keys(marca).filter(function(e){ return e.slice(0,2)===endEst }).length;
  $("#mapa-dir").textContent = "Estante "+endEst.slice(1)+" · "+es[1]+" fileiras × "+ENDB.niveis+" níveis · "+oc+" ocupadas"+
    (filtro? " · "+nm+" com o filtro" : "");
  var lg=limpa($("#legenda"));
  var usadas={}; todosEnd(endEst).forEach(function(e){ var d=catDom(e); if(d!=null) usadas[d]=1 });
  ENDB.cats.forEach(function(nm2,i){
    if(!usadas[i]) return;
    var s=el("span"); var q=el("i"); q.style.background="var(--z"+i+")"; s.appendChild(q);
    s.appendChild(document.createTextNode(nm2+" ("+ENDB.cap[i]+"/prat.)")); lg.appendChild(s);
  });
  var s3=el("span"); s3.appendChild(el("i","leco")); s3.appendChild(document.createTextNode("estoque ativo do e-commerce (vem depois)")); lg.appendChild(s3);
  var s4=el("span"); var q4=el("i"); q4.style.boxShadow="inset 4px 0 0 var(--eco)"; s4.appendChild(q4); s4.appendChild(document.createTextNode("NF + estoque ativo")); lg.appendChild(s4);
  var s2=el("span"); var q2=el("i"); q2.style.borderStyle="dashed"; s2.appendChild(q2); s2.appendChild(document.createTextNode("livre")); lg.appendChild(s2);
  lg.appendChild(el("span",null,"barra = ocupação pela capacidade da categoria"));
}

function gavetaPos(e){
  var L=(ENDP[e]||[]).slice().sort(function(a,b){ return a.o.idx-b.o.idx || ordTam(a.o.tam,b.o.tam) });
  var box=el("div"); box.style.cssText="display:grid;gap:14px";
  if(!L.length){
    box.appendChild(el("p","nota","Prateleira livre. Use “Endereçar peça nova” para colocar algo aqui."));
  } else {
    var grp={}, ordem=[];
    L.forEach(function(x){ var k=x.o.ref+"|"+x.o.cod; if(!grp[k]){ grp[k]=[]; ordem.push(k) } grp[k].push(x) });
    var env=el("div","tab-env"), t=el("table");
    t.appendChild(cabecalho(["Referência","Cor","Tamanhos","Peças"]));
    var tb=el("tbody");
    ordem.forEach(function(k){
      var g=grp[k], o=g[0].o, tr=el("tr",o.eco?"eco":null);
      var pn=el("div","pilha");
      var nb=el("button","lim nome",o.nome); nb.type="button";
      nb.style.cssText="background:none;border:0;padding:0;font:inherit;font-weight:600;color:var(--ac);text-align:left;cursor:pointer";
      nb.onclick=function(){ gavetaSku(o) };
      pn.appendChild(nb); pn.appendChild(el("small","mono",o.ref+" · "+nomeCat(o.cat)));
      if(o.eco) pn.appendChild(tagEl("estoque ativo · vem depois","eco"));
      tr.appendChild(tdNode(pn));
      tr.appendChild(td(o.cor));
      tr.appendChild(td(g.map(function(x){ return x.o.tam+":"+x.q }).join("  ")));
      tr.appendChild(tdD(inteiro(g.reduce(function(a,x){ return a+x.q },0))));
      tb.appendChild(tr);
    });
    t.appendChild(tb); env.appendChild(t); box.appendChild(env);
    var rs=ordem.map(function(k){
      var cs=(ENDCOR[k]||[]).filter(function(o){ return o.res>0 });
      if(!cs.length) return null;
      var o=cs[0];
      return o.nome+" "+o.cor+": "+cs.reduce(function(a,x){ return a+x.res },0)+" peças ("+
        cs.slice().sort(function(a,b){ return ordTam(a.tam,b.tam) }).map(function(x){ return x.tam+":"+x.res }).join(" ")+")";
    }).filter(Boolean);
    if(rs.length){
      box.appendChild(avisoEl("ate","!","Reserva em caixa para repor esta prateleira", rs.join(" · ")));
    }
  }
  var bf=el("button","bt mini","Filtrar a biblioteca por "+e); bf.type="button";
  bf.onclick=function(){ $("#f-end-q").value=e; $("#f-end-q").dispatchEvent(new Event("input",{bubbles:true})); window.fechaGaveta();
    var c=$("#end-corpo"); if(c) c.scrollIntoView({block:"start"}); };
  box.appendChild(bf);
  var cd=catDom(e);
  window.abreGaveta(e, [L.length? nomeCat(cd) : "livre", Math.round(ocup(e)*100)+"% ocupada", inteiro(pecasEm(e))+" peças"], box);
}

function par(dl,rot,val){
  var r=el("div","par"); r.appendChild(el("dt",null,rot));
  var dd=el("dd"); if(val && val.nodeType) dd.appendChild(val); else dd.textContent=(val==null||val==="")?"—":String(val);
  r.appendChild(dd); dl.appendChild(r);
}
function gavetaSku(o){
  var box=el("div"); box.style.cssText="display:grid;gap:16px";
  var dl=el("dl");
  par(dl,"Endereço", o.pos.map(function(p){ return p[0]+(o.pos.length>1? " ("+p[1]+")" : "") }).join(" + ")||"—");
  par(dl,"Na prateleira", inteiro(o.prat)+" peças");
  par(dl,"Na reserva", o.res? inteiro(o.res)+" peças em caixa com a etiqueta "+(o.pos[0]?o.pos[0][0]:"") : "nada");
  par(dl,"SKU", o.sku);
  par(dl,"Referência", o.ref+" · "+nomeCat(o.cat));
  par(dl,"Cor", o.cor+" ("+o.cod+")");
  par(dl,"Tamanho", o.tam);
  par(dl,"Origem", o.novo? "peça nova endereçada aqui" : ("e-commerce "+inteiro(o.ecom)+" · NF 35100 "+inteiro(o.nf)+" (montagem de "+dataBr(ENDB.gerado_em)+")"));
  if(o.aj) par(dl,"Ajuste local", "mudado para "+o.aj.end+" em "+dataBr(o.aj.em)+" — só neste computador");
  box.appendChild(dl);
  var irm=(ENDCOR[o.ref+"|"+o.cod]||[]).filter(function(x){ return x!==o }).sort(function(a,b){ return ordTam(a.tam,b.tam) });
  if(irm.length){
    var p=el("p","nota","Mesma cor, outros tamanhos: "+irm.map(function(x){ return x.tam+" em "+x.end }).join(" · "));
    p.style.margin="0"; box.appendChild(p);
  }
  var f=el("div","ajform");
  var lb=el("label",null,"Mudar para o endereço"); var inp=el("input"); inp.type="text"; inp.placeholder="E1-C05-N3";
  inp.value=o.pos.length===1? o.pos[0][0] : ""; lb.appendChild(inp); f.appendChild(lb);
  var bs=el("button","bt mini pri","Salvar ajuste"); bs.type="button";
  bs.onclick=function(){
    var e=endValido(inp.value);
    if(!e){ inp.focus(); toast("Endereço inválido. Use o formato E1-C05-N3, dentro das estantes."); return }
    var a=AJ[o.sku]||{}; a.end=e; a.em=hojeIso();
    if(o.novo){ a.nome=o.nome; a.cor=o.cor; a.tam=o.tam; a.cat=o.cat; }
    AJ[o.sku]=a;
    if(!gravaAj()){ soLeitura(); return }
    montaEnd(); pintaEnderecos(); window.fechaGaveta(); toast(o.sku+" agora em "+e+" (ajuste local)");
  };
  f.appendChild(bs);
  if(o.aj){
    var bd=el("button","bt mini mau", o.novo? "Remover peça nova" : "Desfazer ajuste"); bd.type="button";
    bd.onclick=function(){ delete AJ[o.sku]; gravaAj(); montaEnd(); pintaEnderecos(); window.fechaGaveta(); toast("Ajuste de "+o.sku+" desfeito"); };
    f.appendChild(bd);
  }
  box.appendChild(f);
  var chips=[o.sku, o.end||"sem endereço", inteiro(o.prat)+" na prateleira"];
  if(o.res) chips.push(tagEl("reserva "+o.res,"a"));
  if(o.aj) chips.push(tagEl("ajuste local","i"));
  if(o.eco) chips.push(tagEl("estoque ativo · vem depois","eco")); else if(!o.novo) chips.push(tagEl("NF 35100","v"));
  window.abreGaveta(o.nome+" · "+o.cor+" · "+o.tam, chips, box);
}

function pintaBibEnd(){
  var L=endFiltrada();
  var k=endOrd.k, d=endOrd.d;
  L.sort(function(a,b){
    var r=0;
    if(k==="nome") r=a.nome.localeCompare(b.nome,"pt") || a.idx-b.idx;
    else if(k==="prat") r=a.prat-b.prat;
    else if(k==="res") r=a.res-b.res;
    else r=a.idx-b.idx || ordTam(a.tam,b.tam);
    return r*d || (a.idx-b.idx) || ordTam(a.tam,b.tam);
  });
  var pcs=L.reduce(function(t,o){ return t+o.prat },0), rs=L.reduce(function(t,o){ return t+o.res },0);
  $("#end-dir").textContent = inteiro(L.length)+" de "+inteiro(ENDS.length)+" SKUs · "+inteiro(pcs)+" na prateleira"+(rs? " · "+inteiro(rs)+" na reserva" : "");
  botaoExport("#end-dir","enderecos-estoque",function(){
    var r=[["Endereço","SKU","Referência","Produto","Categoria","Cor","Cód. cor","Tamanho","Peças na prateleira","Peças na reserva","E-commerce (montagem)","NF 35100","Ajuste local"]];
    L.forEach(function(o){
      r.push([o.end,o.sku,o.ref,o.nome,nomeCat(o.cat),o.cor,o.cod,o.tam,csvNum(o.prat),csvNum(o.res),csvNum(o.ecom),csvNum(o.nf),o.aj?("sim, "+dataBr(o.aj.em)):""]);
    });
    return r;
  });
  var c=limpa($("#end-corpo"));
  if(!L.length){ c.appendChild(el("div","carregando","Nenhum SKU com esse filtro.")); return }
  var vis=L.slice(0,(endPag+1)*END_POR);
  var env=el("div","tab-env"), t=el("table","larga");
  t.appendChild(cabecalho(["Endereço","Produto","Tam","Peças na prateleira","Peças na reserva","Peças e-com / NF"],
    {chaves:{"Endereço":"idx","Produto":"nome","Peças na prateleira":"prat","Peças na reserva":"res"}, k:k, d:d,
     aplica:function(k2,d2){ endOrd={k:k2,d:d2}; endPag=0; pintaBibEnd(); anuncia("Biblioteca ordenada") }}));
  var tb=el("tbody");
  vis.forEach(function(o){
    var tr=el("tr");
    var ce=el("div","pilha");
    o.pos.forEach(function(p,i){ ce.appendChild(el(i?"small":"span","mono", p[0]+(o.pos.length>1? " ("+p[1]+")" : ""))) });
    if(o.aj) ce.appendChild(tagEl(o.novo?"peça nova":"ajuste local","i"));
    if(o.eco){ ce.appendChild(tagEl("estoque ativo · vem depois","eco")); tr.className="eco" }
    tr.appendChild(tdNode(ce));
    var pn=el("div","pilha");
    var nb=el("button","lim nome",o.nome); nb.type="button"; nb.title=o.nome;
    nb.style.cssText="background:none;border:0;padding:0;font:inherit;font-weight:600;color:var(--ac);text-align:left;cursor:pointer";
    nb.onclick=function(){
      Array.prototype.forEach.call(document.querySelectorAll("tr.sel"),function(r){ r.classList.remove("sel") });
      tr.classList.add("sel"); gavetaSku(o);
    };
    pn.appendChild(nb); pn.appendChild(el("small","mono",o.sku+" · "+o.cor));
    tr.appendChild(tdNode(pn));
    tr.appendChild(td(o.tam));
    tr.appendChild(tdD(inteiro(o.prat)));
    var cr=el("td","d"); cr.appendChild(o.res? tagEl(inteiro(o.res),"a") : document.createTextNode("—")); tr.appendChild(cr);
    tr.appendChild(tdD(o.novo? "novo" : inteiro(o.ecom)+" / "+inteiro(o.nf)));
    tb.appendChild(tr);
  });
  t.appendChild(tb); env.appendChild(t); c.appendChild(env);
  if(L.length>vis.length){
    var bm=el("button","bt mini","Mostrar mais "+Math.min(END_POR,L.length-vis.length)+" de "+(L.length-vis.length)+" restantes");
    bm.type="button"; bm.style.margin="10px 13px";
    bm.onclick=function(){ endPag++; pintaBibEnd() };
    c.appendChild(bm);
  }
}

/* sugere a prateleira com mais espaço dentro da zona da categoria; sem espaço, a primeira livre */
function sugereEnd(cat, qtd){
  var cap=ENDB.cap[cat]||25, precisa=(Number(qtd)||1)/cap, melhor=null, folga=-1;
  todosEnd().forEach(function(e){
    if(!ENDP[e]) return;
    if(catDom(e)!==cat) return;
    var f=1-ocup(e);
    if(f>=precisa && f>folga){ folga=f; melhor=e }
  });
  if(melhor) return melhor;
  var livre=todosEnd().filter(function(e){ return !ENDP[e] })[0];
  return livre||null;
}
function pintaAjustes(){
  var c=limpa($("#aj-corpo"));
  var f=el("div","ajform");
  function campo(rot,tipo,ph){ var l=el("label",null,rot); var i=el("input"); i.type=tipo; if(ph) i.placeholder=ph; l.appendChild(i); f.appendChild(l); return i }
  var iSku=campo("SKU","text","222004201100G");
  var iNome=campo("Produto","text","Nome da peça");
  var iCor=campo("Cor","text","Preto");
  var iTam=campo("Tamanho","text","G");
  var lc=el("label",null,"Categoria"), sc=el("select");
  ENDB.cats.forEach(function(n,i){ var op=el("option",null,n); op.value=String(i); sc.appendChild(op) });
  lc.appendChild(sc); f.appendChild(lc);
  var iQ=campo("Peças","number","10"); iQ.min="0";
  var iEnd=campo("Endereço","text","E1-C05-N3");
  c.appendChild(f);
  iSku.addEventListener("change",function(){
    var o=ENDSKU[iSku.value.trim()];
    if(o){ iNome.value=o.nome; iCor.value=o.cor; iTam.value=o.tam; sc.value=String(o.cat); iQ.value=o.prat; iEnd.value=o.pos.length===1?o.pos[0][0]:""; }
    else { var r=iSku.value.trim().slice(0,8), inf=ENDB.refs[r]; if(inf){ iNome.value=inf[0]; sc.value=String(inf[1]) } }
  });
  var lb=el("div","linha-bt");
  var bSug=el("button","bt mini","Sugerir endereço"); bSug.type="button";
  bSug.onclick=function(){
    var s=sugereEnd(Number(sc.value), iQ.value);
    if(s){ iEnd.value=s; toast("Sugestão: "+s+" — "+Math.round((1-ocup(s))*100)+"% livre") }
    else toast("Nenhuma prateleira com espaço para essa quantidade.");
  };
  var bSal=el("button","bt mini pri","Salvar endereço"); bSal.type="button";
  bSal.onclick=function(){
    var s=iSku.value.trim().toUpperCase(), e=endValido(iEnd.value);
    if(!/^[0-9A-Z-]{6,}$/.test(s)){ iSku.focus(); toast("Informe o SKU."); return }
    if(!e){ iEnd.focus(); toast("Endereço inválido. Use o formato E1-C05-N3, dentro das estantes."); return }
    var a={end:e, em:hojeIso()};
    if(!ENDB.skus.some(function(r){ return r[0]===s })){
      a.nome=iNome.value.trim()||"Peça nova"; a.cor=iCor.value.trim()||"—"; a.tam=iTam.value.trim()||"—";
      a.cat=Number(sc.value)||0; a.qtd=Number(iQ.value)||0;
    }
    AJ[s]=a;
    if(!gravaAj()){ soLeitura(); return }
    montaEnd(); pintaEnderecos(); toast(s+" endereçado em "+e+" (ajuste local)");
  };
  lb.appendChild(bSug); lb.appendChild(bSal);
  lb.appendChild(el("span","obs","SKU que já existe só muda de lugar; SKU novo entra na biblioteca"));
  c.appendChild(lb);

  var ks=Object.keys(AJ);
  $("#aj-dir").textContent = ks.length? ks.length+" ajuste"+(ks.length>1?"s":"")+" neste computador" : "nenhum ajuste";
  var lb2=el("div","linha-bt");
  var bEx=el("button","bt mini","Exportar ajustes"); bEx.type="button"; bEx.disabled=!ks.length;
  bEx.onclick=function(){
    var r=[["SKU","Endereço novo","Endereço na base","Produto","Cor","Tamanho","Categoria","Peças","Data"]];
    ks.forEach(function(s){
      var a=AJ[s], base=ENDB.skus.filter(function(x){ return x[0]===s })[0];
      var o=ENDSKU[s]||{};
      r.push([s,a.end, base? base[6].map(function(p){ return p[0] }).join(" + ") : "(novo)", o.nome||a.nome||"", o.cor||a.cor||"", o.tam||a.tam||"",
        nomeCat(o.cat!=null?o.cat:a.cat), csvNum(o.prat!=null?o.prat:a.qtd), a.em]);
    });
    baixaCsv("enderecos-ajustes-"+hojeIso()+".csv", r);
  };
  var bBl=el("button","bt mini","Exportar para o Bling (Codigo;Localizacao)"); bBl.type="button";
  bBl.title="Um SKU por linha, com o endereço atual (base + ajustes). Não envia nada: só gera o arquivo.";
  bBl.onclick=function(){
    var r=[["Codigo","Localizacao"]];
    ENDS.slice().sort(function(a,b){ return a.idx-b.idx || ordTam(a.tam,b.tam) }).forEach(function(o){ r.push([o.sku,o.end]) });
    baixaCsv("bling-localizacao-"+hojeIso()+".csv", r);
  };
  lb2.appendChild(bEx); lb2.appendChild(bBl);
  c.appendChild(lb2);
}

function pintaRegrasEnd(){
  var c=limpa($("#end-regras"));
  var ul=el("ul","regras-end");
  [
    "Endereço = Estante-Fileira-Nível (ex.: E2-C07-N3). De frente para a estante: fileira C01 à esquerda, nível N1 embaixo, N6 no topo. Estante 1 tem 24 fileiras, a 2 tem 11 e a 3 tem 8; todas com 6 níveis.",
    "Zonas em sequência: Camisetas → Camisas → Polos → Batas (Estante 1) · Regatas → Shorts → começo das Bermudas (Estante 2) · Bermudas → Calças → Jaquetas/Conjuntos (Estante 3). Dentro da zona, por referência, com a My Size logo depois da ref base.",
    "Capacidade por prateleira: "+ENDB.cats.map(function(n,i){ return n+" "+ENDB.cap[i] }).join(" · ")+". Uma prateleira pode ter mais de uma referência; uma cor grande ocupa prateleiras seguidas, dividida por tamanho.",
    "Plano único: cada SKU do e-commerce e da NF já tem endereço. Hoje só a NF está fisicamente aqui; os espaços do e-commerce ficam livres até a mudança. Mesmos endereços da página de alocação e do mapa em PDF.",
    "Sem caixa de reserva: tudo cabe nas prateleiras (241 de 258 ocupadas; E3-C06-N2 a E3-C08-N6 livres para crescer).",
    "Quantidades são a foto da montagem ("+dataBr(ENDB.gerado_em)+"). O endereço vale até alguém mudar; a quantidade muda a cada venda. Para saldo do dia, consultar o Bling.",
    "Peça nova ou troca de lugar: salve aqui (fica neste computador), exporte os ajustes e mande para incorporar à base. “Exportar para o Bling” gera o arquivo Codigo;Localizacao, mas NÃO importe antes de trazer o estoque do e-commerce: até lá o site e o Bling seguem com os endereços da fábrica."
  ].forEach(function(t){ ul.appendChild(el("li",null,t)) });
  c.appendChild(ul);
  c.appendChild(el("p","nota","Fonte: "+ENDB.fonte+"."));
}

/* ================= BOOT ================= */
function pintaTudo(){ pintaGeral(); pintaConformidade(); pintaFila(); pintaLojistas(); pintaPedidos(); pintaBase(); pintaReps(); pintaCatalogo(); pintaRegua(); pintaCond(); pintaRegras(); pintaEnderecos(); }

function liga(){
  montaNav();
  if(window.restauraFiltros) window.restauraFiltros();
  var inicial="geral";
  try{ var g=localStorage.getItem("knk-aba"); if(g && ABAS.some(function(a){return a.id===g})) inicial=g; }catch(e){}
  vai(inicial);

  carregaLocal();
  carregaEnd();
  ["f-end-q","f-end-est","f-end-cat","f-end-og","f-end-res","f-end-aj"].forEach(function(id){
    var e=$("#"+id); if(e) e.addEventListener("input",function(){ endPag=0; pintaMapa(); pintaBibEnd() });
  });

  ["f-q","f-uf","f-tipo","f-est","f-ord","f-agenda","f-est2","f-tel","f-hist","f-sit","f-perf"].forEach(function(id){
    var e=$("#"+id); if(e) e.addEventListener("input",function(){ basePag=0; pintaBase() });
  });
  ["f-rep-q","f-rep-sit","f-rep-ct"].forEach(function(id){ var e=$("#"+id); if(e) e.addEventListener("input",pintaReps) });
  ["f-fila-q","f-fila-st","f-fila-vazio"].forEach(function(id){ var e=$("#"+id); if(e) e.addEventListener("input",pintaFila) });
  ["f-cat-q","f-cat-ord","f-cat-fora","p-corte","p-piso","p-fator"].forEach(function(id){
    var e=$("#"+id); if(e) e.addEventListener("input",function(){ pintaCatalogo(); pintaRegua() });
  });
  $("#bt-regua-add").onclick=function(){
    var u=reguaRasc.faixas[reguaRasc.faixas.length-1];
    reguaRasc.faixas.push({min:(u?u.min+4:3), pct:(u?Math.min(u.pct+3,60):5)}); pintaRegua();
  };
  $("#bt-regua-aplicar").onclick=aplicaRegua;
  $("#bt-regua-pausar").onclick=pausaRegua;
  reguaEstado();
  $("#bt-regua-salvar").onclick=function(){
    salvaRegua(); return;
    reguaRasc.faixas.sort(function(a,b){return a.min-b.min});
    reguaRasc.fator=Number($("#p-fator").value)||0.55;
    try{ localStorage.setItem("knk-regua", JSON.stringify(reguaRasc)); REGUA=reguaRasc;
         $("#regua-estado").textContent="régua salva neste computador"; }
    catch(e){ $("#regua-estado").textContent="não consegui salvar"; }
  };
  $("#bt-atualizar").onclick=function(){
    var b=$("#bt-atualizar"); b.disabled=true; b.textContent="…";
    carregaLive().then(function(){ b.disabled=false; b.textContent="Atualizar" });
  };

  pintaTudo();
  carregaLive();
}
/* ================= ENTRADA ================= */
var ACESSO = ["admin","diretoria"], LIGADO=false;
function mostraEntrada(msg){
  var e=$("#entrada"); e.hidden=false;
  $("#e-msg").textContent=msg||"";
  setTimeout(function(){ var c=$("#e-email"); if(c && !c.value) c.focus(); else if($("#e-senha")) $("#e-senha").focus(); },30);
}
function autoriza(sessao){
  var uid=sessao.user.id;
  $("#e-msg").textContent="Conferindo acesso…";
  return sb.from("perfis").select("papel,nome,ativo").eq("id",uid).maybeSingle().then(function(r){
    var p=r.data;
    if(r.error || !p || !p.ativo || ACESSO.indexOf(p.papel)<0){
      sb.auth.signOut();
      mostraEntrada("Este login não tem acesso à Central. Só admin e diretoria entram.");
      return;
    }
    $("#entrada").hidden=true;
    var q=$("#quem"); if(q) q.textContent=(p.nome||sessao.user.email||"")+" · "+p.papel;
    if(LIGADO){ carregaLive(); return; }
    LIGADO=true;
    carregaBanco().then(liga, function(err){
      if(sessaoCaiu(err)){ LIGADO=false; mostraEntrada("Sua sessão expirou. Entre de novo."); return; }
      selo("Não consegui ler o banco","pre");
      toast("Não consegui ler o banco: "+((err&&err.message)||"erro desconhecido"));
    });
  });
}
function entra(){
  sb = window.supabase.createClient(SUPA_URL, SUPA_KEY);
  $("#f-entrada").addEventListener("submit",function(ev){
    ev.preventDefault();
    var b=$("#e-entrar"); b.disabled=true; $("#e-msg").textContent="Entrando…";
    sb.auth.signInWithPassword({email:$("#e-email").value.trim(), password:$("#e-senha").value}).then(function(r){
      b.disabled=false;
      if(r.error || !r.data.session){ $("#e-msg").textContent="E-mail ou senha não conferem."; return; }
      $("#e-senha").value="";
      autoriza(r.data.session);
    });
  });
  $("#bt-sair").onclick=function(){ sb.auth.signOut().then(function(){ location.reload() }) };
  sb.auth.getSession().then(function(r){
    var s=r.data && r.data.session;
    if(s) autoriza(s); else mostraEntrada("");
  });
}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",entra); else entra();
})();
